import axios from 'axios';
import router from './../router';
import Vue from 'vue';
import { decryptAPI, decryptAPICP } from '@/util/crypto';

// import moment from 'moment';
// import {
//   fetchUser,
//   fetchItems,
//   fetchIdsByType
// } from '../api'

/* eslint-disable */
var user_id = 'f6d334f3-fee7-40f4-bc88-a129a86f8d7a';
var username = process.env.VUE_APP_BASIC_USER? process.env.VUE_APP_BASIC_USER : "tracking";
var password = process.env.VUE_APP_BASIC_PASS? process.env.VUE_APP_BASIC_PASS : "pipi@123";
// var credentials = btoa(username + ':' + password);
var basicAuth = 'Basic ' + btoa(username + ':' + password);

// basic auth for source api url (https://oilmine.xyz/)
var usernameSource = "taeloepes2ohSha";
var passwordSource = "va1leLa0pharieyie3Ei";
var credentialsSource = btoa(usernameSource + ':' + passwordSource);
var basicAuthSource = 'Basic ' + credentialsSource;

var defaultHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    // in use basic / bearer token
    'Authorization': basicAuth,
};

var defaultHeadersSource = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    'Authorization': basicAuthSource,
};

// temporary auth token for x-authorization
// let authorization_token = 'Bearer ' + localStorage.getItem('auth_token');
let authorization_token = 'Bearer ' + (localStorage.getItem('vuex') ? JSON.parse(localStorage.getItem('vuex')).auth_token : '');

var defaultAuthHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded',
  'Accept': 'application/json',
  'Authorization': basicAuth,
  'x-app-key': process.env.VUE_APP_APP_KEY,
  'x-secret-key': process.env.VUE_APP_SECRET_KEY,
  'x-authorization': authorization_token,
};

var profile_api_url = process.env.VUE_APP_PROFILE_API_URL;
var overall_api_url = process.env.VUE_APP_OVERALL_API_URL;
var jasaraharja_api_url = process.env.VUE_APP_JASARAHARJA_API_URL;
var source_api_url = process.env.VUE_APP_SOURCE_API_URL;
var bff_master_api_url = process.env.VUE_APP_BFF_MASTER_API_URL;

const CancelToken = axios.CancelToken;
// const axiosSource = axios.CancelToken.source();
// const source = CancelToken.source();
let cancelListRecentLocation, cancelProfileSubheader, cancelProfileSubheaderName, cancelOverallDataLocation, cancelOverallRecentLocation;
let cancelTokenOverallDataLocation = null;

// load_data_status_possible_location: {cancel:null, status:false, code:null},
// load_data_status_aerial_log: {cancel:null, status:false, code:null},
// load_data_status_signal_status: {cancel:null, status:false, code:null},
// load_data_status_vehicles: {cancel:null, status:false, code:null},
// load_data_status_etle: {cancel:null, status:false, code:null},
// load_data_status_get_contact: {cancel:null, status:false, code:null},
// load_data_status_travel_history: {cancel:null, status:false, code:null},
// load_data_status_tokped: {cancel:null, status:false, code:null},
// load_data_status_bank_account: {cancel:null, status:false, code:null},
// load_data_status_personal_identity: {cancel:null, status:false, code:null},

let cancelOverallAppUsage, cancelBrowsingHistory, cancelDeviceHistory, cancelTetheredDevice, cancelPossibleLocation, 
cancelAerialLog, cancelSignalStatus, cancelEtle, cancelFaceRecognition, cancelGetContact, cancelTravelHistory, cancelTokped, 
cancelBankAccount, cancelPersonalIdentity, cancelLocationDetail, cancelLocationHistory, cancelProfileIdentity, cancelProfileFamily, 
cancelVehicles, cancelVehiclesData;

// cancel state for result count -> history location, profile, vehicle
let stateCancelLocationDetail = null,
    stateCancelLocationHistory = null,
    stateCancelProfileIdentity = null,
    stateCancelProfileFamily = null,
    stateCancelVehicles = null,
    stateCancelVehiclesData = null;

export default {

  // for handle errors
  handleErrors ({ commit, dispatch, getters }, status_code=null, module=null) {
    // console.log('handleErrors, status : '+status_code)
    if (status_code !== null) {

      switch(status_code) {
        case 401:
          if (process.env.VUE_APP_AUTH_TYPE === 'api') {
            commit('setAuthToken', null);
            commit('setAuthData', null);

            authorization_token = 'Bearer ';
            defaultAuthHeaders['x-authorization'] = authorization_token;

            if (router.currentRoute.name !== 'pageLogin')
              router.push({ name: 'pageLogin' });
          }
          break;
        case 403:
          if (process.env.VUE_APP_AUTH_TYPE === 'api' && router.currentRoute.name !== 'PageForbidden')
            router.push({ name: 'PageForbidden' });
          break;
        case 429:
          Vue.swal({
            title: getters.getErrorsWording.error429.title,
            text: getters.getErrorsWording.error429.text,
            icon: 'error',
            allowOutsideClick: false,
            allowEscapeKey: false, 
          })
          break;
        case 412:
          Vue.swal({
            title: getters.getErrorsWording.error412.title,
            text: getters.getErrorsWording.error412.text,
            icon: 'error',
            allowOutsideClick: false,
            allowEscapeKey: false, 
          })
          break;
      } 
    }
  },

  // auth
  getLogin({ commit, dispatch }, [username, password]) {

    // console.log('================================= in getLogin()');
    // console.log('{process.env.VUE_APP_APP_KEY, process.env.VUE_APP_SECRET_KEY}');
    // console.log([process.env.VUE_APP_APP_KEY, process.env.VUE_APP_SECRET_KEY]);

    let params = new FormData();

    params.append('email', username);
    params.append('password', password);

    return new Promise((resolve, reject) => {

      axios.post(bff_master_api_url + 'api/v1/auth/login', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
          try {
            var dataApi = JSON.parse(decryptAPI(resp.data.data))
            if (dataApi && dataApi.token) {
              commit('setAuthToken', dataApi.token);
              commit('setAuthData', dataApi.user);

              authorization_token = 'Bearer ' + dataApi.token;
              defaultAuthHeaders['x-authorization'] = authorization_token;

              // resolve(resp);
              resolve({result: 'success', data: dataApi.user});
            } else {
              resolve({result: 'failed', data: dataApi});
            }
          } catch (error) {
            console.log('error login')
            console.log(error)
            resolve({result: 'failed', data: dataApi});
          }
          // console.log(resp)
          // commit('setProfileSubheader', resp.data);

      })
      .catch((resp) => {
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
      });
    });

  },

  getLogout({ commit, dispatch }) {
    // console.log('================================= in getLogout()');

    return new Promise((resolve, reject) => {
      // axios.delete(bff_master_api_url + 'api/v1/auth/logout', {}, {
      axios.delete(bff_master_api_url + 'api/v1/auth/logout', {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        if (resp.status === 200) {
          // localStorage.removeItem('auth_data');
          // localStorage.removeItem('auth_token');
          commit('setAuthToken', null);
          commit('setAuthData', null);
          commit('setDownloadApp', {});

          authorization_token = 'Bearer ';
          defaultAuthHeaders['x-authorization'] = authorization_token;

          // resolve('success');
          resolve({result: 'success', data: resp.data});
        } else {
          // resolve('failed');
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });

  },

  // clients
  getClientsList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null]) {
    // console.log('================================= in getClientsList()')
    commit('setLoadDataStatusClientsList', 'loading');
    
    let params = {
      limit: limit,
      page: page,
      keyword: keyword,
      order_by: order_by,
      from_date: from_date,
      to_date: to_date,
    };
  
    axios.get(bff_master_api_url + 'api/v1/client/list', {
      headers: defaultAuthHeaders,
      params: params,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setClientsList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusClientsList', 'empty');
      } else {
        commit('setLoadDataStatusClientsList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusClientsList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getClientsDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getClientsDetail()')
    // commit('setLoadDataStatusClientsDetail', 'loading');

    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      // axios.get(bff_master_api_url + 'api/v1/client/' + id, {
      axios.post(bff_master_api_url + 'api/v1/client', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setClientsDetail', data);

        resolve('success');

        // if (Object.keys(data).length===0) {
        //   commit('setLoadDataStatusClientsDetail', 'empty');
        // } else {
        //   commit('setLoadDataStatusClientsDetail', true);
        // }
      })
      .catch((resp) => {
        // console.log(resp)
        // commit('setLoadDataStatusClientsDetail', 'failed');
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getClientsCreate({ commit, dispatch }, [name=null, email=null, label=null, key=null, secret=null, status=null, description=null]) {
    // console.log('================================= in getClientsCreate()')
    // commit('setLoadDataStatusClientsCreate', 'loading');

    let params = new FormData();

    params.append('name', name);
    params.append('email', email);
    params.append('label', label);
    params.append('key', key);
    params.append('secret', secret);
    params.append('status', status);
    params.append('description', description);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/client/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          // resolve('success');
          resolve({result: 'success', data: resp.data});
        } else {
          // resolve('failed');
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        // resolve('failed');
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  // getClientsUpdate({ commit, dispatch }, [id, name=null, email=null, label=null, key=null, secret=null, status=null, description=null]) {
  getClientsUpdate({ commit, dispatch }, [id, name=null, label=null, key=null, secret=null, status=null, description=null]) {
    // console.log('================================= in getClientsUpdate()')
    // commit('setLoadDataStatusClientsDetail', 'loading');

    let params = new FormData();

    params.append('id', id);
    params.append('name', name);
    // params.append('email', email);
    params.append('label', label);
    params.append('key', key);
    params.append('secret', secret);
    params.append('status', status);
    params.append('description', description);
  
    return new Promise((resolve, reject) => {
      // axios.post(bff_master_api_url + 'api/v1/client/update/' + id, params, {
      axios.post(bff_master_api_url + 'api/v1/client/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          // resolve('success');
          resolve({result: 'success', data: resp.data});
        } else {
          // resolve('failed');
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        // commit('setLoadDataStatusClientsList', 'failed');
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getClientsLogActivity({ commit, dispatch }, [limit='', page='', keyword='', order_by='', from_date='', to_date='', user_id='']) {
    // console.log('================================= in getClientsLogActivity()')
    commit('setLoadDataStatusClientsLogActivity', 'loading');

    let params = new FormData();

    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    params.append('order_by', order_by);
    params.append('from_date', from_date);
    params.append('to_date', to_date);
    params.append('user_id', user_id);
  
    axios.post(bff_master_api_url + 'api/v1/log-activity/list-client', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setClientsLogActivity', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusClientsLogActivity', 'empty');
      } else {
        commit('setLoadDataStatusClientsLogActivity', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusClientsLogActivity', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getClientsDelete({ commit, dispatch }, [id]) {

    // console.log('================================= in getClientsDelete()');

    let params = new FormData();

    params.append('id', id);

    return new Promise((resolve, reject) => {

      // axios.delete(bff_master_api_url + 'api/v1/client/delete/' + id, {
      axios.post(bff_master_api_url + 'api/v1/client/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        let code = (resp.response && resp.response.status ? resp.response.status : null)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', code);
      });
    });

  },

  // modules
  getModulesList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null]) {
    commit('setLoadDataStatusModulesList', 'loading');
    
    let params = {
      limit: limit,
      page: page,
      keyword: keyword,
      order_by: order_by,
      from_date: from_date,
      to_date: to_date,
    };
  
    axios.get(bff_master_api_url + 'api/v1/module/list', {
      headers: defaultAuthHeaders,
      params: params,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setModulesList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusModulesList', 'empty');
      } else {
        commit('setLoadDataStatusModulesList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setModulesList', {});
      commit('setLoadDataStatusModulesList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getModulesDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getModulesDetail()')

    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      // axios.get(bff_master_api_url + 'api/v1/module/' + id, {
      axios.post(bff_master_api_url + 'api/v1/module', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setModulesDetail', data);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getModulesCreate({ commit, dispatch }, [name='', label='', description='']) {
    // console.log('================================= in getModulesCreate()')

    let params = new FormData();

    params.append('name', name);
    params.append('label', label);
    params.append('description', description);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/module/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getModulesUpdate({ commit, dispatch }, [id, name='', label='', description='']) {
    // console.log('================================= in getModulesUpdate()')

    let params = new FormData();

    params.append('id', id);
    params.append('name', name);
    params.append('label', label);
    params.append('description', description);
  
    return new Promise((resolve, reject) => {
      // axios.post(bff_master_api_url + 'api/v1/module/update/' + id, params, {
      axios.post(bff_master_api_url + 'api/v1/module/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getModulesDelete({ commit, dispatch }, [id]) {

    // console.log('================================= in getModulesDelete()');

    let params = new FormData();

    params.append('id', id);

    return new Promise((resolve, reject) => {

      // axios.delete(bff_master_api_url + 'api/v1/module/delete/' + id, {
      axios.post(bff_master_api_url + 'api/v1/module/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });

  },

  // function modules
  getFunctionList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null]) {
    commit('setLoadDataStatusFunctionList', 'loading');
    
    let params = {
      limit: limit,
      page: page,
      keyword: keyword,
      order_by: order_by,
      from_date: from_date,
      to_date: to_date,
    };
  
    axios.get(bff_master_api_url + 'api/v1/function/list', {
      headers: defaultAuthHeaders,
      params: params,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setFunctionList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusFunctionList', 'empty');
      } else {
        commit('setLoadDataStatusFunctionList', true);
      }
    })
    .catch((resp) => {
      commit('setFunctionList', {});
      // console.log(resp)
      commit('setLoadDataStatusFunctionList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getFunctionDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getFunctionDetail()')

    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      // axios.get(bff_master_api_url + 'api/v1/function/' + id, {
      axios.post(bff_master_api_url + 'api/v1/function', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setFunctionDetail', data);
        resolve('success');
      })
      .catch((resp) => {
        commit('setFunctionDetail', {});
        // console.log(resp)
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getFunctionCreate({ commit, dispatch }, [name='', label='', module_id='', description='']) {
    // console.log('================================= in getFunctionCreate()')

    let params = new FormData();

    params.append('name', name);
    params.append('label', label);
    params.append('module_id', module_id);
    params.append('description', description);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/function/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getFunctionUpdate({ commit, dispatch }, [id, name='', label='', module_id='', description='']) {
    // console.log('================================= in getFunctionUpdate()')

    let params = new FormData();

    params.append('id', id);
    params.append('name', name);
    params.append('label', label);
    params.append('module_id', module_id);
    params.append('description', description);
  
    return new Promise((resolve, reject) => {
      // axios.post(bff_master_api_url + 'api/v1/function/update/' + id, params, {
      axios.post(bff_master_api_url + 'api/v1/function/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getFunctionDelete({ commit, dispatch }, [id]) {

    // console.log('================================= in getFunctionDelete()');

    let params = new FormData();

    params.append('id', id);

    return new Promise((resolve, reject) => {

      // axios.delete(bff_master_api_url + 'api/v1/function/delete/' + id, {
      axios.post(bff_master_api_url + 'api/v1/function/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });

  },

  // roles
  getRolesList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null, client_id=null]) {
    // console.log('================================= in getRolesList()')
    commit('setLoadDataStatusRolesList', 'loading');
    
    let params = {
      limit: limit,
      page: page,
      keyword: keyword,
      order_by: order_by,
      from_date: from_date,
      to_date: to_date,
      client_id: client_id,
    };
  
    axios.get(bff_master_api_url + 'api/v1/role/list', {
      headers: defaultAuthHeaders,
      params: params,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setRolesList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusRolesList', 'empty');
      } else {
        commit('setLoadDataStatusRolesList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusRolesList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getRolesDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getRolesDetail()')

    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      // axios.get(bff_master_api_url + 'api/v1/role/' + id, {
      axios.post(bff_master_api_url + 'api/v1/role', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setRolesDetail', data);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getRolesCreate({ commit, dispatch }, [name=null, label=null, status=null, description=null]) {
    // console.log('================================= in getRolesCreate()')

    let params = new FormData();

    params.append('name', name);
    params.append('label', label);
    // params.append('client_id', client_id);
    params.append('status', status);
    params.append('description', description);
      // temporary ???
    // params.append('label', name);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/role/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getRolesUpdate({ commit, dispatch }, [id, name=null, label=null, status=null, description=null]) {
    // console.log('================================= in getRolesUpdate()')

    let params = new FormData();

    params.append('id', id);
    params.append('name', name);
    params.append('label', label);
    // params.append('client_id', client_id);
    params.append('status', status);
    params.append('description', description);
      // temporary ???
    // params.append('label', name);
  
    return new Promise((resolve, reject) => {
      // axios.post(bff_master_api_url + 'api/v1/role/update/' + id, params, {
      axios.post(bff_master_api_url + 'api/v1/role/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getRolesDelete({ commit, dispatch }, [id]) {

    // console.log('================================= in getRolesDelete()');

    let params = new FormData();

    params.append('id', id);

    return new Promise((resolve, reject) => {

      // axios.delete(bff_master_api_url + 'api/v1/role/delete/' + id, {
      axios.post(bff_master_api_url + 'api/v1/role/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });

  },

  // users
  getUsersList({ state, commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null, client_id=null]) {
    // console.log('================================= in getUsersList()')
    commit('setLoadDataStatusUsersList', 'loading');
    
    let params = {
      limit: limit,
      page: page,
      keyword: keyword,
      order_by: order_by,
      from_date: from_date,
      to_date: to_date,
    };

    if(client_id){
      params['client_id']= client_id;
    }

    axios.get(bff_master_api_url + 'api/v1/user/list', {
      headers: defaultAuthHeaders,
      params: params,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;

      // hide users, if astro & role != superadmin
      if (process.env.VUE_APP_ASTRO === 'true' && state.auth_data.role && state.auth_data.role.label !== 'superadmin') {

        const hide_users = ['cp@baskbt.com'];

        let users_data = data.data;
        users_data = users_data.filter(function(item) {
          return hide_users.indexOf(item.email) === -1;
        });
        data.data = users_data;
      }

      commit('setUsersList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusUsersList', 'empty');
      } else {
        commit('setLoadDataStatusUsersList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusUsersList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getUsersDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getUsersDetail()')

    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      // axios.get(bff_master_api_url + 'api/v1/user/' + id, {
      axios.post(bff_master_api_url + 'api/v1/user', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setUsersDetail', data);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getUsersCreate({ commit, dispatch }, [name='', email='', phone='', client_id='', role_id='', status='', password='', username='', username_bot='', bot_menu=[]]) {
    // console.log('================================= in getUsersCreate()')

    let params = new FormData();

    params.append('name', name);
    params.append('email', email);
    params.append('phone', phone);
    params.append('username', username);
    params.append('username_bot', username_bot);

    if (client_id !== '')
      params.append('client_id', client_id);

    params.append('role_id', role_id);
    params.append('status', status);
    params.append('password', password);
    params.append('bot_menu', bot_menu);
      // temporary ???
    // params.append('label', name);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/user/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getUsersUpdate({ commit, dispatch }, [id, name='', email='', phone='', client_id='', role_id='', status='', password='', username='', username_bot='', bot_menu=[]]) {
    // console.log('================================= in getUsersUpdate()')

    let params = new FormData();

    params.append('id', id);
    params.append('name', name);
    params.append('email', email);
    params.append('phone', phone);
    params.append('username', username);
    params.append('username_bot', username_bot);

    if (client_id !== '')
      params.append('client_id', client_id);

    params.append('role_id', role_id);
    params.append('status', status);
    params.append('password', password);
    params.append('bot_menu', bot_menu);
      // temporary ???
    // params.append('label', name);
  
    return new Promise((resolve, reject) => {
      // axios.post(bff_master_api_url + 'api/v1/user/update/' + id, params, {
      axios.post(bff_master_api_url + 'api/v1/user/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getUsersLogActivity({ commit, dispatch }, [user_id=null, limit='', page='', keyword='',from_date='', to_date='' , order_by='']) {
    // console.log('================================= in getUsersLogActivity()')
    commit('setLoadDataStatusUsersLogActivity', 'loading');

    let params = new FormData();

    if(user_id){
      params.append('user_id', user_id);
    }
    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    params.append('order_by', order_by);
    params.append('from_date', from_date);
    params.append('to_date', to_date);
  
    axios.post(bff_master_api_url + 'api/v1/log-activity/list', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setUsersLogActivity', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusUsersLogActivity', 'empty');
      } else {
        commit('setLoadDataStatusUsersLogActivity', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusUsersLogActivity', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },
  getUsersLogActivityChart({ commit, dispatch }, [from_date='', to_date='']) {
    // console.log('================================= in getUsersLogActivityChart()')
    commit('setLoadDataStatusUsersLogActivityChart', 'loading');

    let params = new FormData();

    params.append('from_date', from_date);
    params.append('to_date', to_date);
  
    axios.post(bff_master_api_url + 'api/v1/log-activity/chart', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setUsersLogActivityChart', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusUsersLogActivityChart', 'empty');
      } else {
        commit('setLoadDataStatusUsersLogActivityChart', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusUsersLogActivityChart', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getUsersLog({ commit, dispatch }, [user_id=null, limit='', page='', keyword='',from_date='', to_date='' , order_by='']) {
    // console.log('================================= in getUsersLog()')
    commit('setLoadDataStatusUsersLog', 'loading');

    let params = new FormData();

    if(user_id){
      params.append('user_id', user_id);
    }
    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    params.append('order_by', order_by);
    params.append('from_date', from_date);
    params.append('to_date', to_date);
    params.append('client_id', 'all');
  
    axios.post(bff_master_api_url + 'api/v1/log-auth/list', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setUsersLog', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusUsersLog', 'empty');
      } else {
        commit('setLoadDataStatusUsersLog', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusUsersLog', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getUsersDelete({ commit, dispatch }, [id]) {

    // console.log('================================= in getUsersDelete()');

    let params = new FormData();

    params.append('id', id);

    return new Promise((resolve, reject) => {

      // axios.delete(bff_master_api_url + 'api/v1/user/delete/' + id, {
      axios.post(bff_master_api_url + 'api/v1/user/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });

  },

  getUsersProfile({ commit, dispatch }, [id]) {
    // console.log('================================= in getUsersProfile()')

    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/profile', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setUsersProfile', data);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getUsersProfileUpdate({ commit, dispatch }, [id, name=null, email=null, role_id=null, status=null, password=null]) {
    // console.log('================================= in getUsersProfileUpdate()')

    let params = new FormData();

    params.append('id', id);
    params.append('name', name);
    params.append('email', email);
    params.append('role_id', role_id);
    params.append('status', status);
    params.append('password', password);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/profile/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  // users tactical
  getUsersTacticalList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null]) {
    // console.log('================================= in getUsersTacticalList()')
    commit('setLoadDataStatusUsersTacticalList', 'loading');

    let params = new FormData();

    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    // params.append('order_by', order_by);
    params.append('from_date', from_date);
    params.append('to_date', to_date);

    axios.post(bff_master_api_url + 'api/v1/user/tactical', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setUsersTacticalList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusUsersTacticalList', 'empty');
      } else {
        commit('setLoadDataStatusUsersTacticalList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusUsersTacticalList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getAclList({ commit, dispatch }) {
    // console.log('================================= in getAclList()')
    commit('setLoadDataStatusAclList', 'loading');
  
    // return new Promise((resolve, reject) => {
      axios.get(bff_master_api_url + 'api/v1/acl/list', {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setAclList', data);
        // resolve('success');

        if (Object.keys(data).length===0) {
          commit('setLoadDataStatusAclList', 'empty');
        } else {
          commit('setLoadDataStatusAclList', true);
        }
      })
      .catch((resp) => {
        // console.log(resp)
        // resolve('failed');
        commit('setLoadDataStatusAclList', 'failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    // });
  },

  getAclUpdate({ commit, dispatch }, [input]) {
    // console.log('================================= in getAclUpdate()')

    let params = new FormData();

    params.append('input', input);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/acl/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'success') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  // territory virtual
  getTerritoryVirtualList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null]) {
    // console.log('================================= in getTerritoryVirtualList()')
    commit('setLoadDataStatusTerritoryVirtualList', 'loading');

    let params = new FormData();

    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    // params.append('order_by', order_by); // error if null (data empty)
    params.append('from_date', from_date);
    params.append('to_date', to_date);
  
    axios.post(bff_master_api_url + 'api/v1/territory-virtual/list', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setTerritoryVirtualList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusTerritoryVirtualList', 'empty');
      } else {
        commit('setLoadDataStatusTerritoryVirtualList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusTerritoryVirtualList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  // for edit / update
  getTerritoryVirtualDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getTerritoryVirtualDetail()')

    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/territory-virtual', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setTerritoryVirtualDetail', data);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getTerritoryVirtualCreate({ commit, dispatch }, [name=null, point=null, target=null, description=null]) {
    // console.log('================================= in getTerritoryVirtualCreate()')

    let params = new FormData();

    params.append('name', name);
    params.append('point', point);
    params.append('target', target);
    params.append('description', description);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/territory-virtual/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getTerritoryVirtualUpdate({ commit, dispatch }, [id, name=null, point=null, target=null, description=null]) {
    // console.log('================================= in getTerritoryVirtualUpdate()')

    let params = new FormData();

    params.append('id', id);
    params.append('name', name);
    params.append('point', point);
    params.append('target', target);
    params.append('description', description);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/territory-virtual/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getTerritoryVirtualDelete({ commit, dispatch }, [id]) {

    // console.log('================================= in getTerritoryVirtualDelete()');

    let params = new FormData();

    params.append('id', id);

    return new Promise((resolve, reject) => {

      axios.post(bff_master_api_url + 'api/v1/territory-virtual/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });

  },

  getTerritoryVirtualUpdateStatus({ commit, dispatch }, [id = null, status = null]) {
    // console.log('================================= in postMonitoring()')
    let params = new FormData();

    params.append('id', id);
    params.append('status', status);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/territory-virtual/update-status', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        if (resp.status === 200) {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  // for detail & notif
  getTerritoryVirtualDetailMapData({ commit, dispatch }, [id, target_id='', msisdn='']) {
    // console.log('================================= in getTerritoryVirtualDetailMapData()')

    let params = new FormData();

    params.append('id', id);
    // if (target_id.length > 0)
      params.append('target_id', target_id);
    // if (msisdn.length > 0)
      params.append('msisdn', msisdn);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/territory-virtual/detail', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setTerritoryVirtualDetailMapData', data);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getTerritoryVirtualDetailHistory({ commit, dispatch }, [id, target_id='', msisdn='', limit='', page='', from_date='', to_date='']) {
    // console.log('================================= in getTerritoryVirtualDetailMapData()')

    if (limit !== '') {
      commit('setLoadDataStatusTerritoryVirtualDetailHistoryList', 'loading');
    } else {
      commit('setLoadDataStatusTerritoryVirtualDetailMapHistory', 'loading');
    }

    let params = new FormData();

    params.append('territory_virtual_id', id);

    // if (target_id.length > 0)
      params.append('target_id', target_id);

    // if (msisdn.length > 0)
      params.append('msisdn', msisdn);

    // if (limit.length > 0)
      params.append('limit', limit);

    // if (page.length > 0)
      params.append('page', page);

    // if (from_date.length > 0)
      params.append('from_date', from_date);

    // if (to_date.length > 0)
      params.append('to_date', to_date);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/territory-virtual/history', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;

        // territory_virtual_detail_map_history: {},
        // territory_virtual_detail_history_list: {},

        if (limit !== '') {
          commit('setTerritoryVirtualDetailHistoryList', data);
          commit('setLoadDataStatusTerritoryVirtualDetailHistoryList', true);
        } else {
          commit('setTerritoryVirtualDetailMapHistory', data);
          commit('setLoadDataStatusTerritoryVirtualDetailMapHistory', true);
        }
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        if (limit !== '') {
          commit('setLoadDataStatusTerritoryVirtualDetailHistoryList', 'failed');
        } else {
          commit('setLoadDataStatusTerritoryVirtualDetailMapHistory', 'failed');
        }
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  // tactical devices
  getTacticalDevicesList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null, map=false]) {
    // console.log('================================= in getTacticalDevicesList()')
    if (map === true) {
      commit('setLoadDataStatusTacticalDevicesListMap', 'loading');
    } else {
      commit('setLoadDataStatusTacticalDevicesList', 'loading');
    }

    let params = new FormData();

    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    // params.append('order_by', order_by); // error if null
    params.append('from_date', from_date);
    params.append('to_date', to_date);
  
    axios.post(bff_master_api_url + 'api/v1/tactical-device/list', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;

      if (map === true) {
        commit('setTacticalDevicesListMap', data);
      } else {
        commit('setTacticalDevicesList', data);
      }

      if (Object.keys(data).length===0) {
        if (map === true) {
          commit('setLoadDataStatusTacticalDevicesListMap', 'empty');
        } else {
          commit('setLoadDataStatusTacticalDevicesList', 'empty');
        }
      } else {
        if (map === true) {
          commit('setLoadDataStatusTacticalDevicesListMap', true);
        } else {
          commit('setLoadDataStatusTacticalDevicesList', true);
        }
      }
    })
    .catch((resp) => {
      // console.log(resp)
      if (map === true) {
        commit('setLoadDataStatusTacticalDevicesListMap', 'failed');
      } else {
        commit('setLoadDataStatusTacticalDevicesList', 'failed');
      }
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getTacticalDevicesMapLocation({ commit, dispatch }, id='') {
    // console.log('================================= in getTacticalDevicesMapLocation()')
    commit('setLoadDataStatusTacticalDevicesMapLocation', 'loading');

    let params = new FormData();
    params.append('device_id', id);
  
    axios.post(bff_master_api_url + 'api/v1/user-tactical-location/list', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;

      // temporary, copy response data
      // let data = [
      //     {
      //         "id": "5f47acbcdc767200072159b6",
      //         "device": {
      //             "id": 1,
      //             "name": "test yusuf",
      //             "device_id": "866984039744287",
      //             "description": "ini untuk test yusuf JANGAN DIUBAH ATAU DIHAPUS"
      //         },
      //         "user": {
      //             "id": "ad90d219-80c3-4fc3-a764-9b57463a546f",
      //             "name": "yusuf tactical",
      //             "photo": "",
      //             "fcm_device_id": "fR8XY4vQTD2AH1G_qHqOle:APA91bHpElJTPOieGJwPVBbCjhWicN-o79cQ7fmti8KrRUAhw-6NNj_YEsi1DdXTmt0uqY9hhYqJkm8cRd5ihfY7D-i7ul-pqruOCEZK7X1-mcaOirVshkfF-C38LCkxeS6F93v8G6mi"
      //         },
      //         "client": {
      //             "id": 105,
      //             "name": "ASTRO",
      //             "label": "astro",
      //             "description": "Astro"
      //         },
      //         "lat": "-7.7778931",
      //         "lng": "110.40738",
      //         "created_at": "2020-08-27 12:53:16+0000",
      //         "updated_at": "2020-08-27 12:53:16+0000"
      //     },
      //     {
      //         "id": "5f47b4c3dc767200072159b8",
      //         "device": {
      //             "id": 15,
      //             "name": "redmi note 9",
      //             "device_id": "test21",
      //             "description": "ini untuk test yusuf JANGAN DIUBAH"
      //         },
      //         "user": {
      //             "id": "3e6a3b8b-975d-4016-9bf3-c621b6576d50",
      //             "name": "yusuf tactical",
      //             "photo": "",
      //             "fcm_device_id": "dcP8p05pSoaSw9uVzD4wuO:APA91bH1-YWesoKUGRDTybsfFMd-Ku7DJ9uD1ckcnNf8NksQIGRzZdtI2uTthxv2Eq5u-mO466JdUanE14JHrIQdWuMAOfy7Cq-v4ZTffPt6Zqn3XOXvWMuTgI0wOlzEEwZ9xAlFepm8"
      //         },
      //         "client": {
      //             "id": 105,
      //             "name": "ASTRO",
      //             "label": "astro",
      //             "description": "Astro"
      //         },
      //         "lat": "0",
      //         "lng": "0",
      //         "created_at": "2020-08-27 13:27:31+0000",
      //         "updated_at": "2020-08-27 13:27:31+0000"
      //     }
      // ];

      commit('setTacticalDevicesMapLocation', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusTacticalDevicesMapLocation', 'empty');
      } else {
        commit('setLoadDataStatusTacticalDevicesMapLocation', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusTacticalDevicesMapLocation', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getTacticalDevicesDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getTacticalDevicesDetail()')

    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/tactical-device', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setTacticalDevicesDetail', data);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getTacticalDevicesCreate({ commit, dispatch }, [name=null, device_id=null, users=null, description=null]) {
    // console.log('================================= in getTacticalDevicesCreate()')

    let params = new FormData();

    params.append('name', name);
    params.append('device_id', device_id); // imei
    params.append('users', users);
    params.append('description', description);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/tactical-device/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getTacticalDevicesUpdate({ commit, dispatch }, [id, name=null, device_id=null, users=null, description=null]) {
    // console.log('================================= in getTacticalDevicesUpdate()')

    let params = new FormData();

    params.append('id', id);
    params.append('name', name);
    params.append('device_id', device_id); // imei
    params.append('users', users);
    params.append('description', description);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/tactical-device/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getTacticalDevicesDelete({ commit, dispatch }, [id]) {

    // console.log('================================= in getTacticalDevicesDelete()');

    let params = new FormData();

    params.append('id', id);

    return new Promise((resolve, reject) => {

      axios.post(bff_master_api_url + 'api/v1/tactical-device/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });

  },

  // case management
  getCaseManagementList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null]) {
    // console.log('================================= in getCaseManagementList()')
    commit('setLoadDataStatusCaseManagementList', 'loading');
    
    let params = {
      limit: limit,
      page: page,
      keyword: keyword,
      order_by: order_by,
      from_date: from_date,
      to_date: to_date,
    };
  
    axios.get(bff_master_api_url + 'api/v1/case-management/list', {
      headers: defaultAuthHeaders,
      params: params,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setCaseManagementList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusCaseManagementList', 'empty');
      } else {
        commit('setLoadDataStatusCaseManagementList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusCaseManagementList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getCaseManagementDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getCaseManagementDetail()')
    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      // axios.get(bff_master_api_url + 'api/v1/case-management/' + id, {
      axios.post(bff_master_api_url + 'api/v1/case-management', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setCaseManagementDetail', data);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getCaseManagementCreate({ commit, dispatch }, [
    operation_name = null,
    location       = null,
    assigns         = null,
    status         = null,
    description    = null
  ]) {
    // console.log('================================= in getCaseManagementCreate()')

    let params = new FormData();

    params.append('operation_name', operation_name);
    params.append('location', location);
    // params.append('client_id', client_id);
    params.append('assigns', assigns);
    params.append('status', status);
    params.append('description', description);
      // temporary ???
    // params.append('label', name);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/case-management/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getCaseManagementUpdate({ commit, dispatch }, [
    id,
    operation_name = null,
    location       = null,
    assigns        = null,
    status         = null,
    description    = null
  ]) {
    // console.log('================================= in getCaseManagementUpdate()')

    let params = new FormData();

    params.append('id', id);
    params.append('operation_name', operation_name);
    params.append('location', location);
    // params.append('client_id', client_id);
    params.append('assigns', assigns);
    params.append('status', status);
    params.append('description', description);
      // temporary ???
    // params.append('label', name);
  
    return new Promise((resolve, reject) => {
      // axios.post(bff_master_api_url + 'api/v1/case-management/update/' + id, params, {
      axios.post(bff_master_api_url + 'api/v1/case-management/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getCaseManagementDelete({ commit, dispatch }, [id]) {

    // console.log('================================= in getCaseManagementDelete()');

    let params = new FormData();

    params.append('id', id);

    return new Promise((resolve, reject) => {

      // axios.delete(bff_master_api_url + 'api/v1/case-management/delete/' + id, {
      axios.post(bff_master_api_url + 'api/v1/case-management/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });

  },

  // single target
  getSingleTargetList({ commit, dispatch, state }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null, param='', no_case_or_cases=null]) {
    // console.log('================================= in getSingleTargetList()')
    let params = {
      limit: limit,
      page: page,
      keyword: keyword,
      order_by: order_by,
      from_date: from_date,
      to_date: to_date,
      no_case_or_cases: no_case_or_cases,
    };
    if(state.load_data_status_single_target_list.cancel != null && state.load_data_status_single_target_list.status == 'loading'){
        // console.log('masuk loading')
        
        state.load_data_status_single_target_list.cancel('Operation canceled by the user.');
        commit('setLoadDataStatusSingleTargetList', { cancel: null, status: 'loading', code: null });
        // console.log(state.load_data_status_single_target_list)
        // console.log(params)
    } 
    // else {
    // const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    // console.log('masuk else')
    commit('setLoadDataStatusSingleTargetList', { cancel: source.cancel, status: 'loading', code: null  });
    // console.log(state.load_data_status_single_target_list)
    // console.log(params)
    var urlApi = 'api/v1/single-target/list' 
    if (param === 'dashboard') {
      urlApi = 'api/v1/single-target/list-cache'
    }

    axios.get(bff_master_api_url + urlApi, {
      headers: defaultAuthHeaders,
      params: params,
      cancelToken: source.token
    })
    .then((resp) => {
      let code = (resp.response && resp.response.status ? resp.response.status : null)

      // console.log(resp.data)
      let data = resp.data;
      commit('setSingleTargetList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSingleTargetList', {cancel: null, status: 'empty', code:code});
      } else {
        commit('setLoadDataStatusSingleTargetList', {cancel: null, status: true});
      }
    })
    .catch((resp) => {
      let code = (resp.response && resp.response.status ? resp.response.status : null)
      if (axios.isCancel(resp)) {
        // console.log('Request canceled aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
        // console.log(resp);
        commit('setLoadDataStatusSingleTargetList', {cancel: null, status: 'loading', code:code});
      } else {
        // handle error
        console.log("cancel error")
        // console.log(resp)
        if (param === 'dashboard') {
          commit('setLoadDataStatusSingleTargetList', {cancel: null, status: 'empty', code:code});
        } else {
          commit('setLoadDataStatusSingleTargetList', {cancel: null, status: 'failed', code:code});
          dispatch('handleErrors', code);
        }
      }
    });
  // }
    // if(source){
    //   console.log('masuk loading2')
      
    //   source.cancel('Operation canceled by the user.');
    // }
  },

  // getSingleTargetTrackingList({ commit, dispatch }, [from_date=null, to_date=null]) {
  getSingleTargetTrackingList({ commit, dispatch }) {
    // console.log('================================= in getSingleTargetTrackingList()')
    commit('setLoadDataStatusSingleTargetTrackingList', 'loading');
    
    let params = new FormData();

    params.append('type', 'last');
    // params.append('from_date', from_date);
    // params.append('to_date', to_date);
    // params.append('target_id', target_id); // string / multiple with array string

    // params.append('system_type', 'monitoringsingle'); ?
  
    // wrong api, for temporary only
    axios.post(bff_master_api_url + 'api/v1/service/overall/recent-location-es', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setSingleTargetTrackingList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSingleTargetTrackingList', 'empty');
      } else {
        commit('setLoadDataStatusSingleTargetTrackingList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusSingleTargetTrackingList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getSingleTargetDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getSingleTargetDetail()')
    commit('setLoadDataStatusSingleTargetDetail', 'loading');

    let params = new FormData();

    params.append('id', id);
    
    return new Promise((resolve, reject) => {
      // axios.get(bff_master_api_url + 'api/v1/single-target/' + id, {
      axios.post(bff_master_api_url + 'api/v1/single-target', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setSingleTargetDetail', data);
        resolve('success');
        if (Object.keys(data).length===0) {
          commit('setLoadDataStatusSingleTargetDetail', 'empty');
        } else {
          commit('setLoadDataStatusSingleTargetDetail', true);
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        commit('setLoadDataStatusSingleTargetDetail', 'failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getSingleTargetCreate({ commit, dispatch }, [
    target_name     = null,
    clues           = null,
    label           = null,
    // status       = null,
    photo           = null,
    cases           = null,
    description     = null,
    additional_info = null
  ]) {

    // console.log('================================= in getSingleTargetCreate()')
    defaultAuthHeaders["Content-Type"]='multipart/form-data; charset=utf-8;'

    let params = new FormData();

    params.append('target_name', target_name);
    params.append('clues', clues);
    params.append('label', label);
    // params.append('status', status);
    params.append('photo', photo);
    params.append('cases', cases);
    params.append('description', description);
    params.append('additional_info', additional_info);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/single-target/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)

        if (resp.status === 200 && (resp.data.message === 'Data Successfully Created' || resp.data.message === 'Data Successfully Updated')) {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getSingleTargetCreateNew({ commit, dispatch }, [
    target_name     = null,
    clues           = null,
    label           = null,
    // status       = null,
    photos           = null,
    cases           = null,
    description     = null,
    additional_info = null
  ]) {

    // console.log('================================= in getSingleTargetCreate()')
    defaultAuthHeaders["Content-Type"]='multipart/form-data; charset=utf-8;'

    let params = new FormData();

    params.append('target_name', target_name);
    params.append('clues', clues);
    params.append('label', label);
    // params.append('status', status);
    // params.append('photos', photos);
    params.append('cases', cases);
    params.append('description', description);
    params.append('additional_info', additional_info);

    for (let index = 0; index < photos.length; index++) {
      params.append('photos', photos[index]);
      
    }

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/single-target/create-new', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)

        if (resp.status === 200 && (resp.data.message === 'Data Successfully Created' || resp.data.message === 'Data Successfully Updated')) {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getSingleTargetUpdate({ commit, dispatch }, [
    id,
    target_name     = null,
    clues           = null,
    label           = null,
    // status       = null,
    photo           = null,
    cases           = null,
    description     = null,
    additional_info = null
  ]) {
    // console.log('================================= in getSingleTargetUpdate()')
    // console.log(photo)
    defaultAuthHeaders["Content-Type"]='multipart/form-data; charset=utf-8;'

    let params = new FormData();

    params.append('id', id);
    params.append('target_name', target_name);
    params.append('clues', clues);
    params.append('label', label);
    // params.append('status', status);
    params.append('photo', photo);
    params.append('cases', cases);
    params.append('description', description);
    params.append('additional_info', additional_info);
  
    return new Promise((resolve, reject) => {
      // axios.post(bff_master_api_url + 'api/v1/single-target/update/' + id, params, {
      axios.post(bff_master_api_url + 'api/v1/single-target/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getSingleTargetUpdateNew({ commit, dispatch }, [
    id,
    target_name     = null,
    clues           = null,
    label           = null,
    // status       = null,
    photos           = null,
    cases           = null,
    description     = null,
    additional_info = null
  ]) {
    // console.log('================================= in getSingleTargetUpdate()')
    // console.log(photos)
    defaultAuthHeaders["Content-Type"]='multipart/form-data; charset=utf-8;'

    let params = new FormData();

    params.append('id', id);
    params.append('target_name', target_name);
    params.append('clues', clues);
    params.append('label', label);
    // params.append('status', status);
    // params.append('photos', photos);
    params.append('cases', cases);
    params.append('description', description);
    params.append('additional_info', additional_info);

    for (let index = 0; index < photos.length; index++) {
      params.append('photos', photos[index]);
      
    }
  
    return new Promise((resolve, reject) => {
      // axios.post(bff_master_api_url + 'api/v1/single-target/update/' + id, params, {
      axios.post(bff_master_api_url + 'api/v1/single-target/update-new', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getSingleTargetDelete({ commit, dispatch }, [id, first=false, force=false]) {

    // console.log('================================= in getSingleTargetDelete()');

    let params = new FormData();

    params.append('id', id);
    if (first)
      params.append('is_first', 'true');
    if (force)
      params.append('is_force', 'true');

    return new Promise((resolve, reject) => {

      // axios.delete(bff_master_api_url + 'api/v1/single-target/delete/' + id, {
      axios.post(bff_master_api_url + 'api/v1/single-target/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });

  },

  // multi tracking / target
  getMultiTrackingList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null]) {
    // console.log('================================= in getMultiTrackingList()')
    commit('setLoadDataStatusMultiTrackingList', 'loading');
    
    let params = {
      limit: limit,
      page: page,
      keyword: keyword,
      order_by: order_by,
      from_date: from_date,
      to_date: to_date,
    };
  
    axios.get(bff_master_api_url + 'api/v1/multi-target/list', {
      headers: defaultAuthHeaders,
      params: params,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setMultiTrackingList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusMultiTrackingList', 'empty');
      } else {
        commit('setLoadDataStatusMultiTrackingList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusMultiTrackingList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getMultiTrackingDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getMultiTrackingDetail()')
    commit('setLoadDataStatusMultiTrackingDetail', 'loading');

    let params = new FormData();

    params.append('id', id);
    
    return new Promise((resolve, reject) => {
      // axios.get(bff_master_api_url + 'api/v1/multi-target/' + id, {
      axios.post(bff_master_api_url + 'api/v1/multi-target', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setMultiTrackingDetail', data);
        resolve('success');
        if (Object.keys(data).length===0) {
          commit('setLoadDataStatusMultiTrackingDetail', 'empty');
        } else {
          commit('setLoadDataStatusMultiTrackingDetail', true);
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve('failed');
        commit('setLoadDataStatusMultiTrackingDetail', 'failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getMultiTrackingCreate({ commit, dispatch }, [
    group_name       = null,
    // clues           = null,
    // label           = null,
    // status          = null,
    // photo           = null,
    cases           = null,
    target          = null,
    additional_info = null,
    description     = null
  ]) {

    // console.log('================================= in getMultiTrackingCreate()')
    // defaultAuthHeaders["Content-Type"]='multipart/form-data; charset=utf-8;'

    let params = new FormData();

    params.append('group_name', group_name);
    // params.append('clues', clues);
    // params.append('label', label);
    // params.append('status', status);
    // params.append('photo', photo);
    params.append('cases', cases);
    params.append('target', target);
    params.append('description', description);
    params.append('additional_info', additional_info);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/multi-target/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)

        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getMultiTrackingUpdate({ commit, dispatch }, [
    id,
    group_name       = null,
    // clues           = null,
    // label           = null,
    // status          = null,
    // photo           = null,
    cases           = null,
    target          = null,
    additional_info = null,
    description     = null
  ]) {
    // console.log('================================= in getMultiTrackingUpdate()')
    // console.log(photo)
    // defaultAuthHeaders["Content-Type"]='multipart/form-data; charset=utf-8;'

    let params = new FormData();

    params.append('id', id);
    params.append('group_name', group_name);
    // params.append('clues', clues);
    // params.append('label', label);
    // params.append('status', status);
    // params.append('photo', photo);
    params.append('cases', cases);
    params.append('target', target);
    params.append('description', description);
    params.append('additional_info', additional_info);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/multi-target/update', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Updated') {
          resolve({result: 'success', data: resp.data});
        } else {
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getMultiTrackingDelete({ commit, dispatch }, [id]) {

    // console.log('================================= in getMultiTrackingDelete()');

    let params = new FormData();

    params.append('id', id);

    return new Promise((resolve, reject) => {

      // axios.delete(bff_master_api_url + 'api/v1/multi-target/delete/' + id, {
      axios.post(bff_master_api_url + 'api/v1/multi-target/delete', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        
        if (resp.status === 200 && resp.data.message === 'Data Successfully Deleted') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getMeetingPointList({ commit, dispatch }, [multi_tracking_id, target_id, limit='', page='', from_date='', to_date='']) {
    // console.log('================================= in getTerritoryVirtualDetailMapData()')

    commit('setLoadDataStatusMeetingPointList', 'loading');
  
    let params = new FormData();

    params.append('multi_tracking_id', multi_tracking_id);
    params.append('target_id', target_id);
    params.append('limit', limit);
    params.append('page', page);
    params.append('from_date', from_date);
    params.append('to_date', to_date);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/meeting-point/list', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;

        // territory_virtual_detail_map_history: {},
        // territory_virtual_detail_history_list: {},

        commit('setMeetingPointList', data);
        commit('setLoadDataStatusMeetingPointList', true);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        commit('setLoadDataStatusMeetingPointList', 'failed');
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getMeetingPointDetail({ commit, dispatch }, [id]) {
    // console.log('================================= in getTerritoryVirtualDetailMapData()')

    commit('setLoadDataStatusMeetingPointDetail', 'loading');
  
    let params = new FormData();

    params.append('id', id);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/meeting-point', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;

        // territory_virtual_detail_map_history: {},
        // territory_virtual_detail_history_list: {},

        commit('setMeetingPointDetail', data);
        commit('setLoadDataStatusMeetingPointDetail', true);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        commit('setLoadDataStatusMeetingPointDetail', 'failed');
        resolve(resp.response && resp.response.statusText ? resp.response.statusText : null);
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  // Monitoring
  postMonitoring({ commit, dispatch }, [
    target_id = null,
    status    = null,
    msisdn    = null,
    frequency = null,
  ]) {
    // console.log('================================= in postMonitoring()')
    let params = new FormData();

    params.append('target_id', target_id);
    params.append('status', status);
    params.append('msisdn', msisdn);
    params.append('frequency', frequency);
    
    // console.log('params')
    // for (var pair of params.entries()) {
    //   console.log(pair[0]+ ', ' + pair[1]); 
    // }
      // console.log(params); 
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/monitoring/single', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)
        // console.log(resp.data.message)
        // if (resp.status === 200 && (resp.data.message === "Successfully Started Monitoring" || resp.data.message === "Successfully Stoped Monitoring")) {
        if (resp.status === 200) {
          // console.log('masuuuuuuuk success')
          resolve({result: 'success', data: resp.data});
        } else {
          // console.log('masuuuuuuuk failed')
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },
  postMultiMonitoring({ commit, dispatch }, [
    multi_tracking_id = null,
    status            = null,
    target            = null,
    frequency         = null,
  ]) {
    // console.log('================================= in postMultiMonitoring()')
    let params = new FormData();

    params.append('multi_tracking_id', multi_tracking_id);
    params.append('status', status);
    params.append('target', target);
    params.append('frequency', frequency);
    
    // console.log('params')
    // for (var pair of params.entries()) {
    //   console.log(pair[0]+ ', ' + pair[1]); 
    // }
      // console.log(params); 
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/monitoring/multi', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        // console.log(resp.status)
        // console.log(resp.data.message)
        // if (resp.status === 200 && (resp.data.message === "Successfully Started Monitoring" || resp.data.message === "Successfully Stoped Monitoring")) {
        if (resp.status === 200) {
          // console.log('masuuuuuuuk success')
          resolve({result: 'success', data: resp.data});
        } else {
          // console.log('masuuuuuuuk failed')
          resolve({result: 'failed', data: resp.data});
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  getSingleMonitoringList({ commit, dispatch }, [target_id, msisdn='', limit='', page='', keyword='', from_date='', to_date='']) {
    // console.log('================================= in getMultiMonitoringList()')
    commit('setLoadDataStatusSingleMonitoringList', 'loading');

    let params = new FormData();

    params.append('target_id', target_id);
    params.append('msisdn', msisdn);
    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    // params.append('order_by', order_by); // error if null (data empty)
    params.append('from_date', from_date);
    params.append('to_date', to_date);
    
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/monitoring/single/list', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;

        commit('setSingleMonitoringList', data);
        commit('setLoadDataStatusSingleMonitoringList', true);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        commit('setLoadDataStatusSingleMonitoringList', 'failed');
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },
  getMultiMonitoringList({ commit, dispatch }, [multi_tracking_id, limit='', page='', keyword='', from_date='', to_date='']) {
    // console.log('================================= in getMultiMonitoringList()')
    commit('setLoadDataStatusMultiMonitoringList', 'loading');

    let params = new FormData();

    params.append('multi_tracking_id', multi_tracking_id);
    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    // params.append('order_by', order_by); // error if null (data empty)
    params.append('from_date', from_date);
    params.append('to_date', to_date);
    
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/monitoring/multi/list', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;

        commit('setMultiMonitoringList', data);
        commit('setLoadDataStatusMultiMonitoringList', true);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        commit('setLoadDataStatusMultiMonitoringList', 'failed');
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },
  // ===============================================================
  getRecentLocationES({ commit, dispatch }, [msisdn, limit='', page='', from_date='', to_date='', system_type='']) {
    // console.log('================================= in getTerritoryVirtualDetailMapData()')

    commit('setLoadDataStatusRecentLocationESList', 'loading');
  
    let params = new FormData();

    params.append('msisdn', msisdn);
    params.append('limit', limit);
    params.append('page', page);
    params.append('from_date', from_date);
    params.append('to_date', to_date);

    if (system_type.length > 0)
      params.append('system_type', 'monitoring'+ system_type);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/service/overall/recent-location-es', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;

        // territory_virtual_detail_map_history: {},
        // territory_virtual_detail_history_list: {},

        commit('setRecentLocationESList', data);
        commit('setLoadDataStatusRecentLocationESList', true);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        commit('setLoadDataStatusRecentLocationESList', 'failed');
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  // ===============================================================
  getTrackingHistoryList({ commit, dispatch }, [limit='', page='', keyword='', from_date='', to_date='']) {
    // console.log('================================= in getTerritoryVirtualDetailMapData()')

    commit('setLoadDataStatusTrackingHistoryList', 'loading');
  
    let params = new FormData();

    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    params.append('from_date', from_date);
    params.append('to_date', to_date);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/tracking-target/list', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;

        commit('setTrackingHistoryList', data);
        commit('setLoadDataStatusTrackingHistoryList', true);
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        commit('setLoadDataStatusTrackingHistoryList', 'failed');
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },
  // ===============================================================
  // Notes Case
  getNoteCaseList({ commit, dispatch }, [loading=true, case_id='', limit='', page='', keyword='', from_date='', to_date='']) {
    // console.log('================================= in getTerritoryVirtualDetailMapData()')
    if (loading) {
      commit('setLoadDataStatusNoteCaseList', 'loading');
    }
  
    let params = new FormData();

    params.append('case_id', case_id);
    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    params.append('from_date', from_date);
    params.append('to_date', to_date);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/note-case/list', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;

        commit('setNoteCaseList', data);
        if (loading) {
          commit('setLoadDataStatusNoteCaseList', true);
        }
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        if (loading) {
          commit('setLoadDataStatusNoteCaseList', 'failed');
        }
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },
  getNoteCaseCreate({
      commit,
      dispatch
    }, [
      case_id = null,
      content = null,
    ]) {

    // console.log('================================= in getNoteCaseCreate()')

    let params = new FormData();

    params.append('case_id', case_id);
    params.append('content', content);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/note-case/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        if (resp.status === 200 && resp.data.message === 'Data Successfully Created') {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },
  // ===============================================================
  // Notes Target
  getNoteTargetList({ commit, dispatch }, [loading=true, target_id='', limit='', page='', keyword='', from_date='', to_date='']) {
    // console.log('================================= in getTerritoryVirtualDetailMapData()')
    if (loading) {
      commit('setLoadDataStatusNoteTargetList', 'loading');
    }
  
    let params = new FormData();

    params.append('target_id', target_id);
    params.append('limit', limit);
    params.append('page', page);
    params.append('keyword', keyword);
    params.append('from_date', from_date);
    params.append('to_date', to_date);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/target-notes/list', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;

        commit('setNoteTargetList', data);
        if (loading) {
          commit('setLoadDataStatusNoteTargetList', true);
        }
        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        if (loading) {
          commit('setLoadDataStatusNoteTargetList', 'failed');
        }
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },
  getNoteTargetCreate({
      commit,
      dispatch
    }, [
      target_id = null,
      notes = null,
    ]) {

    // console.log('================================= in getNoteCaseCreate()')

    let params = new FormData();

    params.append('target_id', target_id);
    params.append('notes', notes);

    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/target-notes/create', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp)
        if (resp.status === 200) {
          resolve('success');
        } else {
          resolve('failed');
        }
      })
      .catch((resp) => {
        // console.log(resp)
        resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },
  // ===============================================================

  // result page
  async getResultData({ state, getters, commit, dispatch }, [key, type, getApi='all', fromSidebar=false, detail_target=false, from_filter_result=false]) {
    // console.log('================================= in getResultData()')

    const default_date = getters.getDefaultDate();

    // if (getApi === 'all')
    // if (
    //   getApi === 'all' ||
    //   getApi === 'result-recent-location' ||
    //   getApi === 'result-profile' || 
    //   getApi === 'result-marketplace' || 
    //   getApi === 'result-vehicles' || 
    //   getApi === 'target-detail-recent-location' ||
    //   getApi === 'target-detail-profile' || 
    //   getApi === 'target-detail-marketplace' ||
    //   getApi === 'target-detail-vehicles'
    // )
    //   await dispatch('setEmptyResultData', []);

    if (getApi === 'all') {
    // set all status to loading, but access api 1 by 1
      await dispatch('setEmptyResultData', [(type === 'nopol'? 'nopol' : 'result'), {cancel:null, status:'loading', code:null}]);
    } else {
      await dispatch('setEmptyResultData', [(type === 'nopol'? 'nopol' : 'result'), {cancel:null, status:false, code:null}, getApi]);
      await dispatch('setEmptyResultData', [(type === 'nopol'? 'nopol' : 'result'), {cancel:null, status:'loading', code:null}, getApi]);
    }

    var record_size = state.record_size!==null ? state.record_size : getters.getDefaultRecordSize;
    var from_date = state.from_date!==null ? state.from_date : default_date.from_date;
    var end_date = state.end_date!==null ? state.end_date : default_date.end_date;

    // 'recent-location',
    // 'application-usage',
    // 'history-location',
    // 'history-browsing',
    // 'device-history',
    // 'tethered-devices',
    // 'possible-location',
    // 'aerial-log',
    // 'signal-status',
    // 'profile',
    // 'get-contactt' -> 'prediction-nickname',
    // 'vehicles',

    // if nopol, change after api vehicle move from jasaraharja to bff master
    // console.log('type:'+type)
    // console.log('getAPI:'+getApi)
    if (type === 'nopol') {
      if (getApi === 'all' || getApi === 'result-vehicles' || getApi === 'target-detail-vehicles') {
        dispatch('getVehicles', [key, type, record_size, from_date, end_date]);
      }

      if (getApi === 'all' || getApi === 'result-etilang' || getApi === 'target-detail-etilang') {
        dispatch('getEtle', [key, type, record_size, from_date, end_date]);
      }

    } else {

      // check is astro
      // if (getApi === 'all')
      if (process.env.VUE_APP_ASTRO === 'true') {
        // console.log('in astro')
        // console.log(process.env.VUE_APP_ASTRO)

        let check_limit = true;
        // await dispatch('getProfileSubheader', [key, type, record_size, from_date, end_date])
        // .then((resp) => {
        //   if (resp.result === 'success' && resp.data.limit_allowed !== true) {
        //     check_limit = false;
        //   }
        // });

        // getLogRecentLocation
        // async getLogRecentLocation({ commit, dispatch, state }, [key='', type='', limit='', page='', from_date='', to_date='']) {
        // dispatch('getLogRecentLocation', [key, type, 10, 1, from_date, end_date]);
        // console.log('date range from getResultData - actions.js', from_date, end_date);
        if (getApi === 'all' || getApi === 'result-recent-location' || getApi === 'target-detail-recent-location') {
            var service_type = 'ext'
            if (getApi === 'target-detail-recent-location')
              service_type = 'int'
            // console.log('getApi 1')
            // console.log(getApi)
            // console.log('service_type 1')
            // console.log(service_type)
            
            await dispatch('getOverallDataLocation', [key, type, record_size, from_date, end_date, service_type, true])
            .then((resp) => {
              // console.log(resp)
              if (resp.result === 'failed' && resp.error_code === 421) {
                check_limit = false;
              }
            });


            // console.log('check_limit: '+ check_limit)
            if (check_limit ===  false)
              return 'not_allowed';
        }
      } else {
        // console.log('not astro')
      
        // if (
        //   getApi === 'all' ||
        //   getApi === 'result-recent-location' ||
        //   getApi === 'result-profile' || 
        //   getApi === 'result-marketplace' || 
        //   getApi === 'target-detail-recent-location' ||
        //   getApi === 'target-detail-profile' || 
        //   getApi === 'target-detail-marketplace'
        // )
        // console.log('state.load_data_status_profile_subheader')
        // console.log(state.load_data_status_profile_subheader)

        // cancel if old request api subheader & recent location is exists
        // if (state.load_data_status_profile_subheader.cancel !== null && state.load_data_status_profile_subheader.status === 'loading') {
        //   try {
        //     await state.load_data_status_profile_subheader.cancel('Operation canceled by the user.');
        //   }
        //   catch(err) {
        //     console.log(err);
        //   }
        // }

        // if (state.load_data_status_overall_data_location.cancel !== null && state.load_data_status_overall_data_location.status === 'loading') {
        //   try {
        //     await state.load_data_status_overall_data_location.cancel('Operation canceled by the user.');
        //   }
        //   catch(err) {
        //     console.log(err);
        //   }
        // }
        console.log("state.load_data_status_profile_subheader")
        console.log(state.load_data_status_profile_subheader)
        console.log("state.load_data_status_profile_subheader_name")
        console.log(state.load_data_status_profile_subheader_name)
        if ((state.load_data_status_profile_subheader_name.status === false || fromSidebar === false) && type !== 'email' && detail_target === false && from_filter_result === false) {
          if (process.env.VUE_APP_ASTRO != 'true') {
            dispatch('getProfileSubheaderName', [key, type]);
            commit('setLoadDataStatusProfileSubheader', {cancel:null,status:'loading', code:null});
            // }
          }
        }

        if ((state.load_data_status_profile_subheader.status === false || fromSidebar === false) && state.load_data_status_profile_subheader.status != 'empty' && type !== 'email' && detail_target === false && from_filter_result === false) {
          if (process.env.VUE_APP_ASTRO === 'true') {
            dispatch('getProfileSubheader', [key, type, record_size, from_date, end_date]);
          } 
        }
          
        if (getApi === 'all' || getApi === 'result-recent-location' || getApi === 'target-detail-recent-location') {
            var service_type = 'ext'
            if (getApi === 'target-detail-recent-location')
              service_type = 'int'
            // console.log('getApi 2')
            // console.log(getApi)
            // console.log('service_type 2')
            // console.log(service_type)
            await dispatch('getOverallDataLocation', [key, type, record_size, state.from_date_recent_location, state.end_date_recent_location, service_type]);
        }
        if (getApi === 'all' || getApi === 'result-application-usage' || getApi === 'target-detail-application-usage') {
            dispatch('getOverallAppUsage', [key, type, record_size, state.from_date_application_usage, state.end_date_application_usage]);
        }

        if (getApi === 'all' || getApi === 'result-history-location' || getApi === 'target-detail-history-location') {

          // cause any component recent location on history location
          if (state.load_data_status_overall_data_location.status === false) {
              var service_type = 'ext'
              if (getApi === 'target-detail-history-location')
                service_type = 'int'
              
              // console.log('getApi 3')
              // console.log(getApi)
              // console.log('service_type 3')
              // console.log(service_type)
              dispatch('getOverallDataLocation', [key, type, record_size, state.from_date_recent_location, state.end_date_recent_location, service_type]);
          }
          dispatch('getLocationDetail', [key, type, record_size, state.from_date_history_location, state.end_date_history_location]);
          dispatch('getLocationHistory', [key, type, record_size, state.from_date_history_location, state.end_date_history_location]);
        }

        if (getApi === 'all' || getApi === 'result-history-browsing' || getApi === 'target-detail-history-browsing') {
          dispatch('getBrowsingAll', [key, type, record_size, state.from_date_history_browsing, state.end_date_history_browsing]);
          // dispatch('getBrowsingHistory', [key, type, record_size, state.from_date_history_browsing, state.end_date_history_browsing]);
          // dispatch('getBrowsingLog', [key, type, record_size, state.from_date_history_browsing, state.end_date_history_browsing]);
          // dispatch('getBrowsingIpAddress', [key, type, record_size, state.from_date_history_browsing, state.end_date_history_browsing]);
          // dispatch('getBrowsingUsage', [key, type, record_size, state.from_date_history_browsing, state.end_date_history_browsing]);
          // dispatch('getBrowsingDuration', [key, type, record_size, state.from_date_history_browsing, state.end_date_history_browsing]);
          // dispatch('getBrowsingAccessDomain', [key, type, record_size, state.from_date_history_browsing, state.end_date_history_browsing]);
        }

        if (getApi === 'all' || getApi === 'result-device-history' || getApi === 'target-detail-device-history')
          dispatch('getDeviceHistory', [key, type, record_size, state.from_date_device_history, state.end_date_device_history]);
        if (getApi === 'all' || getApi === 'result-tethered-devices' || getApi === 'target-detail-tethered-devices')
          dispatch('getTetheredDevice', [key, type, record_size, state.from_date_tethered_devices, state.end_date_tethered_devices]);
        if (getApi === 'all' || getApi === 'result-possible-location' || getApi === 'target-detail-possible-location')
          dispatch('getPossibleLocation', [key, type, record_size, state.from_date_possible_location, state.end_date_possible_location]);
        if (getApi === 'all' || getApi === 'result-aerial-log' || getApi === 'target-detail-aerial-log')
          dispatch('getAerialLog', [key, type, record_size, state.from_date_aerial_log, state.end_date_aerial_log]);
        if (getApi === 'all' || getApi === 'result-signal-status' || getApi === 'target-detail-signal-status')
          dispatch('getSignalStatus', [key, type, record_size, state.from_date_signal_status, state.end_date_signal_status]);

        // case profile with count
        if (getApi === 'all' || getApi === 'result-profile' || getApi === 'target-detail-profile') {
          
          commit('setLoadDataStatusProfileFamily', 'loading');
          await dispatch('getProfileIdentity', [key, type])
          .then((resp) => {
            // console.log('after dispatch getProfileIdentity')
            // console.log(resp)

            if (resp.result === 'success' && resp.data && resp.data.family_id) {
              dispatch('getProfileFamily', [resp.data.family_id, 'nkk']);
            } else {
              commit('setLoadDataStatusProfileFamily', 'failed');
            }
          });
          // dispatch('getProfileFamily', [key, type]);
        }
        if (getApi === 'all' || getApi === 'result-prediction-nickname' || getApi === 'target-detail-prediction-nickname')
          dispatch('getContact', [key, type]);
        
        if (getApi === 'all' || getApi === 'result-travel-history' || getApi === 'target-detail-travel-history')
          dispatch('getTravelHistory', [key, type]);
        console.log('=====getApi')
        console.log(getApi)
        // if (getApi === 'all' || getApi === 'result-travel' || getApi === 'target-detail-travel')
        //   dispatch('getTravelPl', [key, type]);
        
        if (getApi === 'all' || getApi === 'result-marketplace' || getApi === 'target-detail-marketplace')
          dispatch('getTokped', [key, type]);

        if (getApi === 'all' || getApi === 'result-bank-account' || getApi === 'target-detail-bank-account')
          dispatch('getBankAccount', [key, type]);

        if (getApi === 'all' || getApi === 'result-personal-identity' || getApi === 'target-detail-personal-identity')
          dispatch('getPersonalIdentity', [key, type]);
        
        if ((state.load_data_status_profile_subheader.status === false || state.load_data_status_profile_subheader.status === 'loading' || fromSidebar === false) && type !== 'email' && detail_target === false && from_filter_result === false) {
          if (process.env.VUE_APP_ASTRO != 'true') {
            var params = null
            try {
              let recent_location = state.overall_data_location.recent_location
              if(state.load_data_status_location_count.recent == true || state.load_data_status_location_count.recent == 'empty') {
                if(recent_location.features) {
                  params = {
                    msisdn: recent_location.features[0].properties.msisdn && recent_location.features[0].properties.msisdn.length > 0 ? recent_location.features[0].properties.msisdn : '-',
                    imsi: recent_location.features[0].properties.imsi && recent_location.features[0].properties.imsi.length > 0 ? recent_location.features[0].properties.imsi : '-',
                    imei: recent_location.features[0].properties.imei && recent_location.features[0].properties.imei.length > 0 ? recent_location.features[0].properties.imei : '-',
                    device_name: recent_location.features[0].properties.ttype && recent_location.features[0].properties.ttype.length > 0 ? recent_location.features[0].properties.ttype : '-',
                    aol: recent_location.features[0].properties.aol && recent_location.features[0].properties.aol.length > 0 ? recent_location.features[0].properties.aol : '-',
                    state: recent_location.features[0].properties.state && recent_location.features[0].properties.state.length > 0 ? recent_location.features[0].properties.state : '-',
                  }
                }
              } else if(state.load_data_status_profile_count.identity == true) {
                params = {
                  msisdn: state.profile_identity.phone && state.profile_identity.phone.length > 0 ? state.profile_identity.phone[0] : null 
                }
              }
            console.log('params getProfileSubheaderLBS')
            console.log(params)
            } catch (error) {
              console.log('error apaa')
              console.log(error)
            }
            dispatch('getProfileSubheaderLBS', [key, type, params]);
          }
        }
      }
    }
  },

  async setEmptyResultData({ commit, state }, [target=true, status={cancel:null, status:false, code:null}, getApi='all', with_subheader=false]) { // getApi = true = all
    // console.log('getApi')
    // console.log(getApi)
    // console.log('target')
    // console.log(target)
    // console.log('status')
    // console.log(status)
    // console.log([target, status, getApi])

    // temporary ?
    if (target === true || target === 'nopol') {
      if (getApi === 'all' || getApi === 'result-vehicles' || getApi === 'target-detail-vehicles') {
        await commit('setLoadDataStatusVehicles', status);

        if (status.status === false)
          await commit('setVehicles', []);
      }
      if (getApi === 'all' || getApi === 'result-etilang' || getApi === 'target-detail-etilang') {
        await commit('setLoadDataStatusEtle', status);

        if (status.status === false)
          await commit('setEtle', []);
      }
    }

    if (target === true || target === 'result') {

      if (process.env.VUE_APP_ASTRO === 'true') {
        if ((status.status === false || with_subheader === true) && getApi === 'all') {
          await commit('setLoadDataStatusProfileSubheader', {
            status: status.status,
            cancel: state.load_data_status_profile_subheader.cancel,
            code: state.load_data_status_profile_subheader.code,
          });
          await commit('setLoadDataStatusProfileSubheaderName', {
            status: status.status,
            cancel: state.load_data_status_profile_subheader_name.cancel,
            code: state.load_data_status_profile_subheader_name.code,
          });
        }
        
        // await commit('setLoadDataStatusOverallDataLocation', status.status);
        if (getApi === 'all' || getApi === 'result-recent-location' || getApi === 'target-detail-recent-location') {          
            // console.log('setLoadDataStatusOverallDataLocation 1')
            // console.log(status)
            await commit('setLoadDataStatusOverallDataLocation', {
              status: status.status,
              cancel: state.load_data_status_overall_data_location.cancel,
              code: state.load_data_status_overall_data_location.code,
            });
        }

      } else {
        // if (getApi === 'all')
        // console.log(getApi);
        // console.log(status);
        // if (
        //   getApi === 'all' ||
        //   getApi === 'result-recent-location' ||
        //   getApi === 'result-profile' || 
        //   getApi === 'result-marketplace' || 
        //   getApi === 'target-detail-recent-location' ||
        //   getApi === 'target-detail-profile' || 
        //   getApi === 'target-detail-marketplace'
        // )
        if ((status.status === false || with_subheader === true) && getApi === 'all') {

          await commit('setLoadDataStatusProfileSubheader', {
            status: status.status,
            cancel: state.load_data_status_profile_subheader.cancel,
            code: state.load_data_status_profile_subheader.code,
          });
          await commit('setLoadDataStatusProfileSubheaderName', {
            status: status.status,
            cancel: state.load_data_status_profile_subheader_name.cancel,
            code: state.load_data_status_profile_subheader_name.code,
          });
        }
          
        if (getApi === 'all' || getApi === 'result-recent-location' || getApi === 'target-detail-recent-location')
          // await commit('setLoadDataStatusOverallDataLocation', status.status);
          // console.log('setLoadDataStatusOverallDataLocation 2')
          // console.log(status)
          await commit('setLoadDataStatusOverallDataLocation', {
            status: status.status,
            cancel: state.load_data_status_overall_data_location.cancel,
            code: state.load_data_status_overall_data_location.code,
          });

        if (getApi === 'all' || getApi === 'result-application-usage' || getApi === 'target-detail-application-usage')
          await commit('setLoadDataStatusOverallAppUsage', status);

        if (getApi === 'all' || getApi === 'result-history-location' || getApi === 'target-detail-history-location') {
          // await commit('setLoadDataStatusLocation', status.status);
          await commit('setLoadDataStatusLocation', {
            status: status.status,
            cancel: state.load_data_status_location.cancel,
            code: state.load_data_status_location.code,
          });

          // await commit('setLoadDataStatusLocationRecent', (state.load_data_status_overall_data_location !== false ? state.load_data_status_overall_data_location : status));

          await commit('setLoadDataStatusLocationRecent', (status.status === false ? status : (state.load_data_status_overall_data_location !== false ? state.load_data_status_overall_data_location.status : status)));

          await commit('setLoadDataStatusLocationDetail', status.status);
          await commit('setLoadDataStatusLocationHistory', status.status);
        }

        if (getApi === 'all' || getApi === 'result-history-browsing' || getApi === 'target-detail-history-browsing') {
          // await commit('setLoadDataStatusBrowsing', status.status); // old
          await commit('setLoadDataStatusBrowsing', {
            status: status.status,
            cancel: state.load_data_status_browsing.cancel,
            code: state.load_data_status_browsing.code,
          });

          await commit('setLoadDataStatusBrowsingHistory', status.status);
          await commit('setLoadDataStatusBrowsingLog', status.status);
          await commit('setLoadDataStatusBrowsingIpAddress', status.status);
          await commit('setLoadDataStatusBrowsingUsage', status.status);
          await commit('setLoadDataStatusBrowsingDuration', status.status);
          await commit('setLoadDataStatusBrowsingAccessDomain', status.status);
        }

        if (getApi === 'all' || getApi === 'result-device-history' || getApi === 'target-detail-device-history')
          await commit('setLoadDataStatusDeviceHistory', status);
        if (getApi === 'all' || getApi === 'result-tethered-devices' || getApi === 'target-detail-tethered-devices')
          await commit('setLoadDataStatusTetheredDevice', status);
        if (getApi === 'all' || getApi === 'result-possible-location' || getApi === 'target-detail-possible-location')
          await commit('setLoadDataStatusPossibleLocation', status);
        if (getApi === 'all' || getApi === 'result-aerial-log' || getApi === 'target-detail-aerial-log')
          await commit('setLoadDataStatusAerialLog', status);
        if (getApi === 'all' || getApi === 'result-signal-status' || getApi === 'target-detail-signal-status')
          await commit('setLoadDataStatusSignalStatus', status);

        // case profile with count
        if (getApi === 'all' || getApi === 'result-profile' || getApi === 'target-detail-profile') {
          // await commit('setLoadDataStatusProfile', status.status); // old
          await commit('setLoadDataStatusProfile', {
            status: status.status,
            cancel: state.load_data_status_profile.cancel,
            code: state.load_data_status_profile.code,
          });
          await commit('setLoadDataStatusProfileIdentity', status.status);
          await commit('setLoadDataStatusProfileFamily', status.status);
        }

        if (getApi === 'all' || getApi === 'result-prediction-nickname' || getApi === 'target-detail-prediction-nickname')
          commit('setLoadDataStatusGetContact', status);

        if (getApi === 'all' || getApi === 'result-travel-history' || getApi === 'target-detail-travel-history')
          commit('setLoadDataStatusTravelHistory', status);

        if (getApi === 'all' || getApi === 'result-travel' || getApi === 'target-detail-travel')
          commit('setLoadDataStatusTravel', status);

        if (getApi === 'all' || getApi === 'result-marketplace' || getApi === 'target-detail-marketplace')
          commit('setLoadDataStatusTokped', status);
        
        if (getApi === 'all' || getApi === 'result-bank-account' || getApi === 'target-detail-bank-account')
          commit('setLoadDataStatusBankAccount', status);

        if (getApi === 'all' || getApi === 'result-personal-identity' || getApi === 'target-detail-personal-identity')
          commit('setLoadDataStatusPersonalIdentity', status);
      }

      // ----------------------------------------------------------

      if (status.status === false) {
        // console.log('masuk false')
        // console.log('===============')

        if (process.env.VUE_APP_ASTRO === 'true') {
          await commit('setProfileSubheader', {});
          await commit('setOverallDataLocation', {});

        } else {

          if (getApi === 'all')
          // if (
          //   getApi === 'all' ||
          //   getApi === 'result-recent-location' ||
          //   getApi === 'result-profile' || 
          //   getApi === 'result-marketplace' || 
          //   getApi === 'target-detail-recent-location' ||
          //   getApi === 'target-detail-profile' || 
          //   getApi === 'target-detail-marketplace'
          // )
            await commit('setProfileSubheader', {});
          
          if (getApi === 'all' || getApi === 'result-recent-location' || getApi === 'target-detail-recent-location')
            await commit('setOverallDataLocation', {});
          if (getApi === 'all' || getApi === 'result-application-usage' || getApi === 'target-detail-application-usage')
            await commit('setOverallAppUsage', {});
          
          if (getApi === 'all' || getApi === 'result-history-location' || getApi === 'target-detail-history-location') {
            await commit('setLocationDetail', {});
            await commit('setLocationHistory', {});
          }

          if (getApi === 'all' || getApi === 'result-history-browsing' || getApi === 'target-detail-history-browsing') {
            await commit('setBrowsingHistory', {});
            await commit('setBrowsingLog', {});
            await commit('setBrowsingIpAddress', {});
            await commit('setBrowsingUsage', {});
            await commit('setBrowsingDuration', {});
            await commit('setBrowsingAccessDomain', {});
          }

          if (getApi === 'all' || getApi === 'result-device-history' || getApi === 'target-detail-device-history')
            await commit('setDeviceHistory', []);
          if (getApi === 'all' || getApi === 'result-tethered-devices' || getApi === 'target-detail-tethered-devices')
            await commit('setTetheredDevice', {});
          if (getApi === 'all' || getApi === 'result-possible-location' || getApi === 'target-detail-possible-location')
            await commit('setPossibleLocation', {});
          if (getApi === 'all' || getApi === 'result-aerial-log' || getApi === 'target-detail-aerial-log')
            await commit('setAerialLog', {});
          if (getApi === 'all' || getApi === 'result-signal-status' || getApi === 'target-detail-signal-status')
            await commit('setSignalStatus', {});
          
          if (getApi === 'all' || getApi === 'result-profile' || getApi === 'target-detail-profile') {
            await commit('setProfileIdentity', {});
            await commit('setProfileFamily', []);
          }

          if (getApi === 'all' || getApi === 'result-prediction-nickname' || getApi === 'target-detail-prediction-nickname')
            await commit('setGetContact', {});
          
          if (getApi === 'all' || getApi === 'result-travel-history' || getApi === 'target-detail-travel-history')
            await commit('setTravelHistory', {});
            
          if (getApi === 'all' || getApi === 'result-travel' || getApi === 'target-detail-travel')
            await commit('setTravel', {});
          
          if (getApi === 'all' || getApi === 'result-marketplace' || getApi === 'target-detail-marketplace')
            await commit('setTokped', {});
          if (getApi === 'all' || getApi === 'result-bank-account' || getApi === 'target-detail-bank-account')
            await commit('setBankAccount', {});

          if (getApi === 'all' || getApi === 'result-personal-identity' || getApi === 'target-detail-personal-identity')
            await commit('setPersonalIdentity', {});
        }
      }
    }
  },

  async cancelResultApi({ state, commit }) {

    if (state.load_data_status_profile_subheader.cancel !== null && state.load_data_status_profile_subheader.status === 'loading')
      await state.load_data_status_profile_subheader.cancel('Operation canceled by the user.');

    if (state.load_data_status_profile_subheader_name.cancel !== null && state.load_data_status_profile_subheader_name.status === 'loading')
      await state.load_data_status_profile_subheader_name.cancel('Operation canceled by the user.');

    if (state.load_data_status_overall_app_usage.cancel !== null && state.load_data_status_overall_app_usage.status === 'loading')
      await state.load_data_status_overall_app_usage.cancel('Operation canceled by the user.');

    if (state.load_data_status_overall_data_location.cancel !== null && state.load_data_status_overall_data_location.status === 'loading')
      await state.load_data_status_overall_data_location.cancel('Operation canceled by the user.');

    // if (state.load_data_status_overall_log_recent_location.cancel !== null && state.load_data_status_overall_log_recent_location.status === 'loading')
    //   await state.load_data_status_overall_log_recent_location.cancel('Operation canceled by the user.');

    // if (state.load_data_status_location.cancel !== null && state.load_data_status_location.status === 'loading')
    //   await state.load_data_status_location.cancel('Operation canceled by the user.');
    if (stateCancelLocationDetail !== null && state.load_data_status_location_count.detail === 'loading')
      await stateCancelLocationDetail('Operation canceled by the user.');
    if (stateCancelLocationHistory !== null && state.load_data_status_location_count.history === 'loading')
      await stateCancelLocationHistory('Operation canceled by the user.');

    if (state.load_data_status_browsing.cancel !== null && state.load_data_status_browsing.status === 'loading')
      await state.load_data_status_browsing.cancel('Operation canceled by the user.');

    if (state.load_data_status_device_history.cancel !== null && state.load_data_status_device_history.status === 'loading')
      await state.load_data_status_device_history.cancel('Operation canceled by the user.');

    if (state.load_data_status_tethered_device.cancel !== null && state.load_data_status_tethered_device.status === 'loading')
      await state.load_data_status_tethered_device.cancel('Operation canceled by the user.');

    // if (state.load_data_status_profile.cancel !== null && state.load_data_status_profile.status === 'loading')
    //   await state.load_data_status_profile.cancel('Operation canceled by the user.');
    if (stateCancelProfileIdentity !== null && state.load_data_status_profile_count.identity === 'loading')
      await stateCancelProfileIdentity('Operation canceled by the user.');
    if (stateCancelProfileFamily !== null && state.load_data_status_profile_count.family === 'loading')
      await stateCancelProfileFamily('Operation canceled by the user.');

    if (state.load_data_status_possible_location.cancel !== null && state.load_data_status_possible_location.status === 'loading')
      await state.load_data_status_possible_location.cancel('Operation canceled by the user.');

    if (state.load_data_status_aerial_log.cancel !== null && state.load_data_status_aerial_log.status === 'loading')
      await state.load_data_status_aerial_log.cancel('Operation canceled by the user.');

    if (state.load_data_status_signal_status.cancel !== null && state.load_data_status_signal_status.status === 'loading')
      await state.load_data_status_signal_status.cancel('Operation canceled by the user.');

    // if (state.load_data_status_vehicles.cancel !== null && state.load_data_status_vehicles.status === 'loading')
    //   await state.load_data_status_vehicles.cancel('Operation canceled by the user.');
    if (stateCancelVehicles !== null && state.load_data_status_vehicles.status === 'loading')
      await stateCancelVehicles('Operation canceled by the user.');
    if (stateCancelVehiclesData !== null && state.load_data_status_vehicles.status === 'loading')
      await stateCancelVehiclesData('Operation canceled by the user.');

    // if (state.load_data_status_vehicles.status === 'loading') {
    //   let result = {
    //     // status: 'failed',
    //     status: false,
    //     cancel: null,
    //     code: null,
    //   };

    //   commit('setLoadDataStatusVehicles', result);
    // }

    if (state.load_data_status_etle.cancel !== null && state.load_data_status_etle.status === 'loading')
      await state.load_data_status_etle.cancel('Operation canceled by the user.');

    if (state.load_data_status_get_contact.cancel !== null && state.load_data_status_get_contact.status === 'loading')
      await state.load_data_status_get_contact.cancel('Operation canceled by the user.');

    if (state.load_data_status_travel_history.cancel !== null && state.load_data_status_travel_history.status === 'loading')
      await state.load_data_status_travel_history.cancel('Operation canceled by the user.');

    if (state.load_data_status_travel.cancel !== null && state.load_data_status_travel.status === 'loading')
      await state.load_data_status_travel.cancel('Operation canceled by the user.');

    if (state.load_data_status_tokped.cancel !== null && state.load_data_status_tokped.status === 'loading')
      await state.load_data_status_tokped.cancel('Operation canceled by the user.');

    if (state.load_data_status_bank_account.cancel !== null && state.load_data_status_bank_account.status === 'loading')
      await state.load_data_status_bank_account.cancel('Operation canceled by the user.');

    if (state.load_data_status_personal_identity.cancel !== null && state.load_data_status_personal_identity.status === 'loading')
      await state.load_data_status_personal_identity.cancel('Operation canceled by the user.');

  },

  // profile
  async getProfileSubheader({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {

    // console.log('================================= in getProfileSubheader()')

    if (state.load_data_status_profile_subheader.cancel !== null && state.load_data_status_profile_subheader.status === 'loading')
      await state.load_data_status_profile_subheader.cancel('Operation canceled by the user.');

    // temporary device setDeviceHistory
    // commit('setLoadDataStatusDeviceHistory', 'loading');
    // commit('setLoadDataStatusTetheredDevice', 'loading');

    let params = new FormData();

    params.append('key', key);
    params.append('type', type);

    // await axios.post(profile_api_url + 'api/profile/subheader', params, {
    // await axios.post(bff_master_api_url + 'api/v1/service/rig/subheader', params, {

    return await axios.post(bff_master_api_url + 'api/v1/service/overall/subheader', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelProfileSubheader = c;
        commit('setLoadDataStatusProfileSubheader', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
      // headers: defaultHeaders,
      // params: {
      //   user_id: user_id,
      // },
    })
    .then((resp) => {
      // console.log(resp)
      // let code = (resp.response && resp.response.status ? resp.response.status : null)      
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };
      commit('setProfileSubheader', resp.data);

      // if (resp.data.imsi) {
      //   dispatch('getTetheredDevice', [resp.data.imsi, from_date, end_date]);
      //   dispatch('getDeviceHistory', [resp.data.imsi, record_size, from_date, end_date])
      // } else {
      //   commit('setLoadDataStatusTetheredDevice', 'failed');
      //   commit('setLoadDataStatusDeviceHistory', 'failed');
      // }

      commit('setLoadDataStatusProfileSubheader', result);

      return {
        result: 'success',
        data: resp.data
      };
    })
    .catch((resp) => {
      // console.log(resp)
      // let code = (resp.response && resp.response.status ? resp.response.status : null)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelProfileSubheader;
      }

      commit('setLoadDataStatusProfileSubheader', result);

      // temporary device setDeviceHistory
      // commit('setLoadDataStatusTetheredDevice', 'failed');
      // commit('setLoadDataStatusDeviceHistory', 'failed');
      dispatch('handleErrors', result.code);
      return {
        result: 'failed',
      };
    });
  },

  async getProfileSubheaderLBS({ commit, dispatch, state }, [key, type, addParams]) {
    // console.log('================================= in getProfileSubheaderLBS()')
    if (state.load_data_status_profile_subheader.cancel !== null && state.load_data_status_profile_subheader.status === 'loading')
      await state.load_data_status_profile_subheader.cancel('Operation canceled by the user.');

    let params = new FormData();

    params.append('key', key);
    params.append('type', type);
    if (addParams != null) {        
      for (var keyParam in addParams ) {
        params.append(keyParam, addParams[keyParam]);
      }
    }
    return await axios.post(bff_master_api_url + 'api/v1/service/overall/subheader-target-lbs', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelProfileSubheader = c;
        commit('setLoadDataStatusProfileSubheader', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
      // headers: defaultHeaders,
      // params: {
      //   user_id: user_id,
      // },
    })
    .then((resp) => {
      // console.log(resp)
      // let code = (resp.response && resp.response.status ? resp.response.status : null)      
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };
      commit('setProfileSubheader', resp.data);

      // if (resp.data.imsi) {
      //   dispatch('getTetheredDevice', [resp.data.imsi, from_date, end_date]);
      //   dispatch('getDeviceHistory', [resp.data.imsi, record_size, from_date, end_date])
      // } else {
      //   commit('setLoadDataStatusTetheredDevice', 'failed');
      //   commit('setLoadDataStatusDeviceHistory', 'failed');
      // }

      commit('setLoadDataStatusProfileSubheader', result);

      return {
        result: 'success',
        data: resp.data
      };
    })
    .catch((resp) => {
      // console.log(resp)
      // let code = (resp.response && resp.response.status ? resp.response.status : null)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelProfileSubheader;
      }

      commit('setLoadDataStatusProfileSubheader', result);

      // temporary device setDeviceHistory
      // commit('setLoadDataStatusTetheredDevice', 'failed');
      // commit('setLoadDataStatusDeviceHistory', 'failed');
      dispatch('handleErrors', result.code);
      return {
        result: 'failed',
      };
    });
  },
  async getProfileSubheaderName({ commit, dispatch, state }, [key, type]) {
    // console.log('================================= in getProfileSubheaderName()')
    if (state.load_data_status_profile_subheader_name.cancel !== null && state.load_data_status_profile_subheader_name.status === 'loading')
      await state.load_data_status_profile_subheader_name.cancel('Operation canceled by the user.');

    let params = new FormData();

    params.append('key', key);
    params.append('type', type);

    return await axios.post(bff_master_api_url + 'api/v1/service/overall/subheader-name', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelProfileSubheaderName = c;
        commit('setLoadDataStatusProfileSubheaderName', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
      // headers: defaultHeaders,
      // params: {
      //   user_id: user_id,
      // },
    })
    .then((resp) => {
      // console.log(resp)
      // let code = (resp.response && resp.response.status ? resp.response.status : null)      
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };
      commit('setProfileSubheaderName', resp.data);

      // if (resp.data.imsi) {
      //   dispatch('getTetheredDevice', [resp.data.imsi, from_date, end_date]);
      //   dispatch('getDeviceHistory', [resp.data.imsi, record_size, from_date, end_date])
      // } else {
      //   commit('setLoadDataStatusTetheredDevice', 'failed');
      //   commit('setLoadDataStatusDeviceHistory', 'failed');
      // }
      
      commit('setLoadDataStatusProfileSubheaderName', result);

      return {
        result: 'success',
        data: resp.data
      };
    })
    .catch((resp) => {
      // console.log(resp)
      // let code = (resp.response && resp.response.status ? resp.response.status : null)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelProfileSubheaderName;
      }
      commit('setLoadDataStatusProfileSubheaderName', result);

      // temporary device setDeviceHistory
      // commit('setLoadDataStatusTetheredDevice', 'failed');
      // commit('setLoadDataStatusDeviceHistory', 'failed');
      dispatch('handleErrors', result.code);
      return {
        result: 'failed',
      };
    });
  },

  async getProfileIdentity({ commit, dispatch, state }, [key, type]) {
    // console.log('================================= in getProfileIdentity()')

    commit('setLoadDataStatusProfile', {cancel:null, status:'loading', code:null}); // global sidebar menu
    // commit('setLoadDataStatusProfileIdentity', 'loading'); // old
    if (stateCancelProfileIdentity !== null && state.load_data_status_profile_count.identity === 'loading')
      await stateCancelProfileIdentity('Operation canceled by the user.');

    let params = new FormData();

    params.append('key', key);
    params.append('type', type);

    return await axios.post(bff_master_api_url + 'api/v1/service/rig/ktp', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelProfileIdentity = c;
        commit('setLoadDataStatusProfileIdentity', 'loading');
        stateCancelProfileIdentity = c;
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let status = true;

      commit('setProfileIdentity', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusProfileIdentity', 'empty');
        status = 'empty';
      }
      
      stateCancelProfileIdentity = null;
      commit('setLoadDataStatusProfileIdentity', status);

      return {
        result: 'success',
        data: data
      };
    })
    .catch((resp) => {
      // console.log('failed profile identity')
      // console.log(resp.response)
      let status = 'failed';

      if (axios.isCancel(resp)) {
        status = 'loading';
        stateCancelProfileIdentity = cancelProfileIdentity;
      }

      commit('setLoadDataStatusProfileIdentity', status);
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));

      return {
        result: status,
      };
    });
  },

  async getProfileFamily({ commit, dispatch, state }, [key, type]) {
    // console.log('================================= in getProfileFamily()')

    // commit('setLoadDataStatusProfile', {cancel:null, status:'loading', code:null});
    // commit('setLoadDataStatusProfileFamily', 'loading'); // old
    if (stateCancelProfileFamily !== null && state.load_data_status_profile_count.Family === 'loading')
      await stateCancelProfileFamily('Operation canceled by the user.');

    let params = new FormData();

    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/rig/kk', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelProfileFamily = c;
        commit('setLoadDataStatusProfileFamily', 'loading');
        stateCancelProfileFamily = c;
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let status = true;

      commit('setProfileFamily', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusProfileFamily', 'empty');
        status = 'empty';
      }
      
      stateCancelProfileFamily = null;
      commit('setLoadDataStatusProfileFamily', status);
    })
    .catch((resp) => {
      // console.log('failed profile family')
      // console.log(resp.response.status)
      let status = 'failed';

      if (axios.isCancel(resp)) {
        status = 'loading';
        stateCancelProfileFamily = cancelProfileFamily;
      }

      commit('setLoadDataStatusProfileFamily', status);
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  async getContact({ commit, dispatch, state }, [key, type]) {

    // commit('setLoadDataStatusGetContact', {cancel:null, status:'loading', code:null});
    if (state.load_data_status_get_contact.cancel !== null && state.load_data_status_get_contact.status === 'loading')
      await state.load_data_status_get_contact.cancel('Operation canceled by the user.');

    let params = new FormData();
    if (type == 'msisdn') {
      params.append('key', key);
    } else {
      key = state.profile_subheader?state.profile_subheader.msisdn:null
      params.append('key', key);
    }

    await axios.post(bff_master_api_url + 'api/v1/service/prediction/prediction-name', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelGetContact = c;
        commit('setLoadDataStatusGetContact', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      try {
        if (typeof(data.prediction_name) == 'object') {
          data.prediction_name = Object.keys(data.prediction_name).map((key) => key.toUpperCase());
        }
      } catch (error) {
        
      }
      try {
        if (typeof(data.tags) == 'object') {
          data.tags = Object.keys(data.tags).map((key) => key.toUpperCase());
        }
      } catch (error) {
        
      }

      commit('setGetContact', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusGetContact', {cancel:null, status:'empty', code:code});
        result.status = 'empty';
      }
      
      commit('setLoadDataStatusGetContact', result);
    })
    .catch((resp) => {
      // console.log(resp.response.status)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelGetContact;        
      }

      commit('setLoadDataStatusGetContact', result);
      dispatch('handleErrors', result.code);
    });
  },

  // ==============================================

  // overall
  async getOverallAppUsage({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {

    if (state.load_data_status_overall_app_usage.cancel !== null && state.load_data_status_overall_app_usage.status === 'loading')
      await state.load_data_status_overall_app_usage.cancel('Operation canceled by the user.');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    // console.log('=====params:overall');
    // console.log(from_date);
    // console.log(end_date);

    // axios.post(overall_api_url + 'api/overall/app-usage', params, {
    //   headers: defaultHeaders,
    //   params: {
    //       user_id: user_id,
    //   },
    // })
    await axios.post(bff_master_api_url + 'api/v1/service/overall/app-usage', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelOverallAppUsage = c;
        commit('setLoadDataStatusOverallAppUsage', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // let code = (resp.response && resp.response.status ? resp.response.status : null)
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };
      let data = resp.data;

      commit('setOverallAppUsage', data);

      if (Object.keys(data.app_usage).length===0 && Object.keys(data.data_usage_app.categories).length===0 && Object.keys(data.data_usage_cat.categories).length===0) {

        // commit('setLoadDataStatusOverallAppUsage',{cancel:null,status:'empty', code:code});
        result.status = 'empty';

      } else if (Object.keys(data.app_usage).length===0 || Object.keys(data.data_usage_app.categories).length===0 || Object.keys(data.data_usage_cat.categories).length===0) {

        // commit('setLoadDataStatusOverallAppUsage',{cancel:null,status:'partially-empty', code:code});
        result.status = 'partially-empty';
      }
      
      commit('setLoadDataStatusOverallAppUsage', result);
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelOverallAppUsage;        
      }

      commit('setLoadDataStatusOverallAppUsage', result);
      dispatch('handleErrors', result.code);
    });
  },

  async cancelForceOverallDataLocation({ commit, state }) {
    if (state.load_data_status_overall_data_location.cancel !== null && state.load_data_status_overall_data_location.status === 'loading') {
      await state.load_data_status_overall_data_location.cancel('Operation canceled by the user.');
      let result = {
        // status: 'failed',
        status: false,
        cancel: null,
        // cancel: cancelOverallRecentLocation,
        // code: resp.response && resp.response.status ? resp.response.status : null,
        code: null,
      };
      // console.log(1)
      await commit('setOverallDataLocation', {});

      // if (axios.isCancel(resp)) {
      //   result.status = 'loading';
      //   result.cancel = cancelOverallRecentLocation;
      // }

      // commit('setLoadDataStatusOverallDataLocation','failed');
      // commit('setLoadDataStatusLocationRecent','failed');
      // await commit('setLoadDataStatusOverallDataLocation', true);
      // console.log(2)
      // console.log('setLoadDataStatusOverallDataLocation 3')
      // console.log(result)
      await commit('setLoadDataStatusOverallDataLocation', result);
      // console.log(3)
      await commit('setLoadDataStatusLocationRecent', result.status);
    }
  },

  async getOverallDataLocation({ commit, dispatch, state, getters }, [key, type, record_size, from_date, end_date, service_type, astro=false]) {

    // if (astro === false)
    // commit('setLoadDataStatusOverallDataLocation','loading');
    if (state.load_data_status_overall_data_location.cancel !== null && state.load_data_status_overall_data_location.status === 'loading') {
      try {
        await state.load_data_status_overall_data_location.cancel('Operation canceled by the user.');
      }
      catch(err) {
        console.log(err);
      }
    }

    // commit('setLoadDataStatusLocationRecent','loading');

    let params = new FormData();

    // params.append('size', record_size);
    // params.append('from_date', from_date);
    // old api
    // params.append('end_date', end_date);
    // bff master api
    // params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    let data = {
      data_location: {},
      heatmap: [],
      recent_location: {},
    };

    // console.log(astro)
    if (astro === true) {
      var service = 'service-'+service_type
      var pathUrlEnc = 'api/v1/service/overall/recent-location/internal/encrypt'
      var cache = false
      // console.log('setLoadDataStatusOverallDataLocation 4')
      // console.log(service)
      // console.log(service == 'service-ext')
      if(service == 'service-ext') {
        pathUrlEnc = 'api/v1/service/overall/recent-location/external/encrypt'
        cache = true
        var lsKey = key + '_' + service + '_recent-location'
      } 
      
      var pathUrl = 'api/v1/'+service+'/overall/recent-location'
      var isEncryptCP = process.env.VUE_APP_ENCRYPT_RECENT_LOCATION || false
      if (isEncryptCP)
        pathUrl = pathUrlEnc

      try {
        let resp = getters.getApiResp(lsKey)
        if (resp==null) throw "Empty"
        
        // console.log('JSON.parse(resp)')
        // console.log(JSON.parse(resp))
        dispatch('setRecentLocation', [JSON.parse(resp), data]);
        return {
          result: 'success',
          // data: resp.data
        };
      } catch (error) {
        console.log('error LS')
        console.log(error)
        var returnData = {}
        // await axios.post(bff_master_api_url + 'api/v1/'+service+'/overall/recent-location', params, {
        await axios.post(bff_master_api_url + pathUrl, params, {
          headers: defaultAuthHeaders,
          cancelToken: new CancelToken(function executor(c) {
            cancelOverallRecentLocation = c;
            commit('setLoadDataStatusOverallDataLocation', {
              status: 'loading',
              cancel: c,
              code: null,
            });
            commit('setLoadDataStatusLocationRecent', 'loading'); // ?
          }),
        })
        .then((resp) => {
          console.log('CP1 : BEGIN')
          if (isEncryptCP && resp.data.data)
            resp.data = JSON.parse(decryptAPICP(resp.data.data))
          console.log({resp})
          console.log('CP1 : END')
          dispatch('setRecentLocation', [resp, data]);
          if (cache) {
            // console.log('masuk cache true')
            let dt = {
              resp: resp, 
              lsKey: lsKey
            }
            // console.log('dt')
            // console.log(dt)
            dispatch('addApiResp', dt);
            // console.log('dtaaaaa')
          }
          returnData = {
            result: 'success',
            // data: resp.data
          };
        })
        .catch((resp) => {
          // console.log(resp)
          // let code = (resp.response && resp.response.status ? resp.response.status : null)
          let result = {
            status: 'failed',
            cancel: null,
            code: resp.response && resp.response.status ? resp.response.status : null,
          };
          let result_conclusion = 'failed';

          if (state.load_data_status_overall_data_location.cancel === null) {
            result = {
              status: false,
              cancel: null,
              code: null,
            };
            result_conclusion = 'cancel';

          } else {

            if (axios.isCancel(resp)) {
              result.status = 'loading';
              result.cancel = cancelOverallRecentLocation;
              
              result_conclusion = 'cancel';
            }
          }

          commit('setOverallDataLocation', {});

          // commit('setLoadDataStatusOverallDataLocation','failed');
          // commit('setLoadDataStatusLocationRecent','failed');
          // console.log('setLoadDataStatusOverallDataLocation 6')
          // console.log(result)
          commit('setLoadDataStatusOverallDataLocation', result);
          commit('setLoadDataStatusLocationRecent', result.status);

          dispatch('handleErrors', result.code);
          returnData = {
            // result: 'failed',
            result: result_conclusion,
            error_code: result.code,
          };
        });
        return returnData
      }

    // ---------------------------------------------------------------------------------------------------------------------

    } else {
      if(process.env.VUE_APP_GET_RECENT_LOCATION == 'full'){
        params.append('size', record_size);
        params.append('from_date', from_date);
        params.append('to_date', end_date);
        
        if (cancelTokenOverallDataLocation !== null && state.load_data_status_overall_data_location.status === 'loading') {
          try {
            await cancelTokenOverallDataLocation('Operation canceled by the user.');
          }
          catch(err) {
            console.log(err);
          }
        }

        // await axios.all(api)
        var service = 'service-'+service_type

        var pathUrlEnc = 'api/v1/service/overall/recent-location/internal/encrypt'
        if(service == 'service-ext') 
          pathUrlEnc = 'api/v1/service/overall/recent-location/external/encrypt'
        
        var pathUrl = 'api/v1/'+service+'/overall/recent-location'
        var isEncryptCP = process.env.VUE_APP_ENCRYPT_RECENT_LOCATION || false
        if (isEncryptCP)
          pathUrl = pathUrlEnc

        await axios.all([

          // data location
          axios.post(bff_master_api_url + 'api/v1/service/overall/data-location', params, {
            headers: defaultAuthHeaders,
            cancelToken: new CancelToken(function executor(c) {
              cancelOverallDataLocation = c;
            }),
          })
          .then((resp) => {
            cancelTokenOverallDataLocation = null;
            // console.log(resp)
            return resp;
          })
          .catch((resp) => {
            // console.log(resp)
            if (axios.isCancel(resp))
              cancelTokenOverallDataLocation = cancelOverallDataLocation;

            return null;
            dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
          }),

          // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

          // recent location
          // axios.post(bff_master_api_url + 'api/v1/'+service+'/overall/recent-location', params, {
          axios.post(bff_master_api_url + pathUrl, params, {
            headers: defaultAuthHeaders,
            cancelToken: new CancelToken(function executor(c) {
              cancelOverallRecentLocation = c;
              commit('setLoadDataStatusOverallDataLocation', {
                status: 'loading',
                cancel: c,
                code: null,
              });
              commit('setLoadDataStatusLocationRecent', 'loading'); // ?
            }),
          })
          .then((resp) => {
            console.log('CP2 : BEGIN')
            // console.log(resp.data)

            if (isEncryptCP && resp.data.data)
              resp.data = JSON.parse(decryptAPICP(resp.data.data))
            console.log({resp})
            console.log('CP2 : END')

            let result = {
              status: state.load_data_status_overall_data_location.status,
              cancel: null,
              code: state.load_data_status_overall_data_location.code,
            };
            // console.log('setLoadDataStatusOverallDataLocation 7')
            // console.log(result)
            commit('setLoadDataStatusOverallDataLocation',result);

            return resp;
          })
          .catch((resp) => {
            // console.log(resp)
            // return resp;
            let result = {
              status: state.load_data_status_overall_data_location.status,
              cancel: state.load_data_status_overall_data_location.cancel,
              code: state.load_data_status_overall_data_location.code,
            };

            if (axios.isCancel(resp)) {
              result.status = 'loading';
              result.cancel = cancelOverallRecentLocation;
            }
            // console.log('setLoadDataStatusOverallDataLocation 8')
            // console.log(result)
            commit('setLoadDataStatusOverallDataLocation', result);

            return null;
            dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
          }),

        ])
        .then(axios.spread((data_location_resp=null, recent_location_resp) => {
          data.data_location = data_location_resp.data.data_location;
          data.heatmap = data_location_resp.data.heatmap;
          data.recent_location = recent_location_resp.data;
          let code = (recent_location_resp.response && recent_location_resp.response.status ? recent_location_resp.response.status : null)

          commit('setOverallDataLocation', data);

          if (Object.keys(data.data_location).length===0 && Object.keys(data.heatmap).length===0 && (data.recent_location.features[0].geometry.coordinates && (data.recent_location.features[0].geometry.coordinates[0]==="" || data.recent_location.features[0].geometry.coordinates[1]===""))) {

            commit('setLoadDataStatusOverallDataLocation','empty');
            commit('setLoadDataStatusLocationRecent','empty');

          } else if (Object.keys(data.data_location).length===0 || Object.keys(data.heatmap).length===0 || (data.recent_location.features[0].geometry.coordinates && (data.recent_location.features[0].geometry.coordinates[0]==="" || data.recent_location.features[0].geometry.coordinates[1]===""))) {

            commit('setLoadDataStatusOverallDataLocation', 'partially-empty');
            commit('setLoadDataStatusLocationRecent', 'partially-empty');
          } else {
            commit('setLoadDataStatusOverallDataLocation', true);
            commit('setLoadDataStatusLocationRecent', true);
          }
        }))
        .catch((resp) => {
          let code = (resp.response && resp.response.status ? resp.response.status : null)
          // commit('setOverallDataLocation', data);
          commit('setOverallDataLocation', {});
          commit('setLoadDataStatusOverallDataLocation', 'failed');
          commit('setLoadDataStatusLocationRecent', 'failed');
        });

        // ---------------------------------------------------------------------------------------------------------------------
        
        // console.log('process.env.VUE_APP_GET_RECENT_LOCATION === fulll')

      } else {
        var service = 'service-'+service_type
        
        var pathUrlEnc = 'api/v1/service/overall/recent-location/internal/encrypt'
        
        var cache = false
        if(service == 'service-ext') {
          pathUrlEnc = 'api/v1/service/overall/recent-location/external/encrypt'
          cache = true
          var lsKey = key + '_' + service + '_recent-location'
        } 

        var pathUrl = 'api/v1/'+service+'/overall/recent-location'
        var isEncryptCP = process.env.VUE_APP_ENCRYPT_RECENT_LOCATION || false
        if (isEncryptCP)
          pathUrl = pathUrlEnc

        try {
          let resp = getters.getApiResp(lsKey)
          if (resp==null) throw "Empty"
          
          // console.log('JSON.parse(resp)')
          // console.log(JSON.parse(resp))
          dispatch('setRecentLocation', [JSON.parse(resp), data]);
          return {
            result: 'success',
            // data: resp.data
          };
        } catch (error) {
          console.log('error LS')
          console.log(error)
          var returnData = {}
          // await axios.post(bff_master_api_url + 'api/v1/'+service+'/overall/recent-location', params, {
          await axios.post(bff_master_api_url + pathUrl, params, {
            headers: defaultAuthHeaders,
            cancelToken: new CancelToken(function executor(c) {
              cancelOverallRecentLocation = c;
              commit('setLoadDataStatusOverallDataLocation', {
                status: 'loading',
                cancel: c,
                code: null,
              });
              commit('setLoadDataStatusLocationRecent', 'loading'); // ?
            }),
          })
          .then((resp) => {
            console.log('CP3 : BEGIN')
            if (isEncryptCP && resp.data.data)
              resp.data = JSON.parse(decryptAPICP(resp.data.data))
            console.log({resp})
            console.log('CP3 : END')
            dispatch('setRecentLocation', [resp, data]);
            if (cache) {
              let dt = {
                resp: resp, 
                lsKey: lsKey
              }
              dispatch('addApiResp', dt);
            }
            returnData = {
              result: 'success',
              // data: resp.data
            };
          })
          .catch((resp) => {
            // console.log(resp)
            // let code = (resp.response && resp.response.status ? resp.response.status : null)
            let result = {
              status: 'failed',
              cancel: null,
              code: resp.response && resp.response.status ? resp.response.status : null,
            };
            let result_conclusion = 'failed';

            if (axios.isCancel(resp)) {
              result.status = 'loading';
              result.cancel = cancelOverallRecentLocation;
              
              result_conclusion = 'cancel';
            }


            commit('setOverallDataLocation', {});
            // commit('setLoadDataStatusOverallDataLocation', 'failed');
            // commit('setLoadDataStatusLocationRecent', 'failed');
            // console.log('setLoadDataStatusOverallDataLocation 11')
            // console.log(result)
            commit('setLoadDataStatusOverallDataLocation', result);
            commit('setLoadDataStatusLocationRecent', result.status);

            dispatch('handleErrors', result.code);
            returnData = {
              // result: 'failed',
              result: result_conclusion,
              error_code: result.code,
            };
          });
          return returnData
        }
      }
    }
  },

  async getLogRecentLocation({ commit, dispatch, state }, [key='', type='', limit='', page='', from_date='', to_date='']) {

      if (state.load_data_status_overall_log_recent_location.cancel !== null && state.load_data_status_overall_log_recent_location.status === 'loading')
        await state.load_data_status_overall_log_recent_location.cancel('Operation canceled by the user.');
      
      let params = new FormData();
      
      params.append('key', key);
      params.append('type', type);
      params.append('limit', limit);
      params.append('page', page);
      params.append('from_date', from_date);
      params.append('to_date', to_date);
      params.append('system_type', 'web');

      await axios.post(bff_master_api_url + 'api/v1/service/overall/recent-location-detail', params, {
        headers: defaultAuthHeaders,
        cancelToken: new CancelToken(function executor(c) {
          cancelListRecentLocation = c;
          commit('setLoadDataStatusOverallLogRecentLocation', {
            status: 'loading',
            cancel: c,
            code: null,
          });
        }),
      })
      .then((resp) => {
        let data = resp.data;
        let result = {
          status: true,
          cancel: null,
          code: resp.response && resp.response.status ? resp.response.status : null,
        };

        commit('setOverallLogRecentLocation', data);

        if (Object.keys(data).length===0)
          result.status = 'empty';

        commit('setLoadDataStatusOverallLogRecentLocation', result);
      })
      .catch((resp) => {
        let result = {
          status: 'failed',
          cancel: null,
          code: resp.response && resp.response.status ? resp.response.status : null,
        };

        // if (axiosOrigin.isCancel(resp)) {
        if (axios.isCancel(resp)) {
          result.status = 'loading';
          result.cancel = cancelListRecentLocation;
        }

        commit('setLoadDataStatusOverallLogRecentLocation', result);
        // dispatch('errors/handleApiResponse', [result.code, (resp.response.data && resp.response.data.message ? resp.response.data.message : null)], { root: true });
        dispatch('handleErrors', result.code);
      });
    },

  // ==============================================
  // Location

  async getLocationDetail({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {

    // commit('setLoadDataStatusLocation', 'loading');
    commit('setLoadDataStatusLocation', {cancel:null, status:'loading', code:null}); // global, for menu sidebar
    // commit('setLoadDataStatusLocationDetail', 'loading'); // old
    if (stateCancelLocationDetail !== null && state.load_data_status_location_count.detail === 'loading')
      await stateCancelLocationDetail('Operation canceled by the user.');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/overall/detail-location', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelLocationDetail = c;
        commit('setLoadDataStatusLocationDetail', 'loading');
        stateCancelLocationDetail = c;
      }),
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      let status = true;
      commit('setLocationDetail', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusLocationDetail', 'empty');
        status = 'empty';

      } else {

        if (
          (typeof data.detail_location_village.categories == "undefined" || data.detail_location_village.categories.length == 0) &&
          data.detail_location_village.series.length == 0 &&
          data.detail_location_village.pie.length == 0 &&

          (typeof data.detail_location_region.categories == "undefined" || data.detail_location_region.categories.length == 0) &&
          data.detail_location_region.series.length == 0 &&
          data.detail_location_region.pie.length == 0 &&

          (typeof data.detail_location_province.categories == "undefined" || data.detail_location_province.categories.length == 0) &&
          data.detail_location_province.series.length == 0 &&
          data.detail_location_province.pie.length == 0 &&

          (typeof data.detail_location_city.categories == "undefined" || data.detail_location_city.categories.length == 0) &&
          data.detail_location_city.series.length == 0 &&
          data.detail_location_city.pie.length == 0
        ) {
          // commit('setLoadDataStatusLocationDetail', 'empty');
          status = 'empty';

        } else if (
          typeof data.detail_location_village.categories == "undefined" ||
          data.detail_location_village.categories.length == 0 ||
          data.detail_location_village.series.length == 0 ||
          data.detail_location_village.pie.length == 0 ||

          typeof data.detail_location_region.categories == "undefined" ||
          data.detail_location_region.categories.length == 0 ||
          data.detail_location_region.series.length == 0 ||
          data.detail_location_region.pie.length == 0 ||

          typeof data.detail_location_province.categories == "undefined" ||
          data.detail_location_province.categories.length == 0 ||
          data.detail_location_province.series.length == 0 ||
          data.detail_location_province.pie.length == 0 ||

          typeof data.detail_location_city.categories == "undefined" ||
          data.detail_location_city.categories.length == 0 ||
          data.detail_location_city.series.length == 0 ||
          data.detail_location_city.pie.length == 0
        ) {
          // commit('setLoadDataStatusLocationDetail', 'partially-empty');
          status = 'partially-empty';
        }
      }

      stateCancelLocationDetail = null;
      commit('setLoadDataStatusLocationDetail', status);

    })
    .catch((resp) => {
      // console.log(resp)
      let status = 'failed';

      if (axios.isCancel(resp)) {
        status = 'loading';
        stateCancelLocationDetail = cancelLocationDetail;
      }

      commit('setLoadDataStatusLocationDetail', status);
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  async getLocationHistory({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {

    // commit('setLoadDataStatusLocation', 'loading'); // old -> global, sidebar menu
    // commit('setLoadDataStatusLocationHistory', 'loading'); // old
    if (stateCancelLocationHistory !== null && state.load_data_status_location_count.history === 'loading')
      await stateCancelLocationHistory('Operation canceled by the user.');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/overall/location-history', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelLocationHistory = c;
        commit('setLoadDataStatusLocationHistory', 'loading');
        stateCancelLocationHistory = c;
      }),
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      let status = true;
      commit('setLocationHistory', data);

      if (data.length===0) {
        // commit('setLoadDataStatusLocationHistory', 'empty');
        status = 'empty';
      }
      
      stateCancelLocationHistory = null;
      commit('setLoadDataStatusLocationHistory', status);
    })
    .catch((resp) => {
      // console.log(resp)
      let status = 'failed';

      if (axios.isCancel(resp)) {
        status = 'loading';
        stateCancelLocationHistory = cancelLocationHistory;
      }

      commit('setLoadDataStatusLocationHistory', status);
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  // ==============================================
  // Browsing

  async getBrowsingAll({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {

    // commit('setLoadDataStatusBrowsing', 'loading'); // old
    // commit('setLoadDataStatusBrowsing', {cancel:null, status:'loading', code:null});
    if (state.load_data_status_browsing.cancel !== null && state.load_data_status_browsing.status === 'loading')
      await state.load_data_status_browsing.cancel('Operation canceled by the user.');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/overall/browsing-all', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelBrowsingHistory = c;
        commit('setLoadDataStatusBrowsing', {
          status: 'loading',
          cancel: c,
          code: null,
        });
        commit('setLoadDataStatusBrowsingHistory', 'loading');
        commit('setLoadDataStatusBrowsingLog', 'loading');
        commit('setLoadDataStatusBrowsingIpAddress', 'loading');
        commit('setLoadDataStatusBrowsingUsage', 'loading');
        commit('setLoadDataStatusBrowsingDuration', 'loading');
        commit('setLoadDataStatusBrowsingAccessDomain', 'loading');
      }),
    })
    .then((resp) => {
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setBrowsingHistory', data.browsing_history);
      commit('setBrowsingLog', data.browsing_log);
      commit('setBrowsingIpAddress' , data.browsing_ip_address);
      commit('setBrowsingUsage', data.browsing_usage);
      commit('setBrowsingDuration', data.browsing_duration);
      commit('setBrowsingAccessDomain', data.browsing_access_domain);

      if (data.browsing_history.length===0)
        result.status = 'empty';

      commit('setLoadDataStatusBrowsingHistory', result.status);
      commit('setLoadDataStatusBrowsingLog', result.status);
      commit('setLoadDataStatusBrowsingIpAddress', result.status);
      commit('setLoadDataStatusBrowsingUsage', result.status);
      commit('setLoadDataStatusBrowsingDuration', result.status);
      commit('setLoadDataStatusBrowsingAccessDomain', result.status);

      commit('setLoadDataStatusBrowsing', result);
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelBrowsingHistory;

        commit('setLoadDataStatusBrowsingHistory', result.status);
        commit('setLoadDataStatusBrowsingLog', result.status);
        commit('setLoadDataStatusBrowsingIpAddress', result.status);
        commit('setLoadDataStatusBrowsingUsage', result.status);
        commit('setLoadDataStatusBrowsingDuration', result.status);
        commit('setLoadDataStatusBrowsingAccessDomain', result.status);
      }

      commit('setLoadDataStatusBrowsing', result);
      dispatch('handleErrors', result.code);
    });
  },

  // old browsing history, merge to 1 request above
  async getBrowsingHistory({ commit, dispatch }, [key, type, record_size, from_date, end_date]) {

    commit('setLoadDataStatusBrowsing', {cancel:null, status:'loading', code:null});
    commit('setLoadDataStatusBrowsingHistory', 'loading');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/overall/browsing-history', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {

      let data = resp.data;

      commit('setBrowsingHistory', data);

      if (data.length===0) {
        commit('setLoadDataStatusBrowsingHistory', 'empty');
      } else {
        commit('setLoadDataStatusBrowsingHistory', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusBrowsingHistory', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  async getBrowsingLog({ commit, dispatch }, [key, type, record_size, from_date, end_date]) {

    commit('setLoadDataStatusBrowsing', {cancel:null, status:'loading', code:null});
    commit('setLoadDataStatusBrowsingLog', 'loading');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/overall/browsing-log', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {

      let data = resp.data;

      commit('setBrowsingLog', data);

      if (data.chart_browser.categories === undefined) {
        commit('setLoadDataStatusBrowsingLog', 'empty');
      } else {
        commit('setLoadDataStatusBrowsingLog', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusBrowsingLog', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  async getBrowsingIpAddress({ commit, dispatch }, [key, type, record_size, from_date, end_date]) {

    commit('setLoadDataStatusBrowsing', {cancel:null, status:'loading', code:null});
    commit('setLoadDataStatusBrowsingIpAddress', 'loading');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/overall/browsing-ip-address', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {

      let data = resp.data;

      commit('setBrowsingIpAddress', data);

      if (data.chart_client_ip.categories === undefined) {
        commit('setLoadDataStatusBrowsingIpAddress', 'empty');
      } else {
        commit('setLoadDataStatusBrowsingIpAddress', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusBrowsingIpAddress', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  async getBrowsingUsage({ commit, dispatch }, [key, type, record_size, from_date, end_date]) {

    commit('setLoadDataStatusBrowsing', {cancel:null, status:'loading', code:null});
    commit('setLoadDataStatusBrowsingUsage', 'loading');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/overall/browsing-usage', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {

      let data = resp.data;

      commit('setBrowsingUsage', data);

      if (data.chart_usage_app_cat.categories === undefined) {
        commit('setLoadDataStatusBrowsingUsage', 'empty');
      } else {
        commit('setLoadDataStatusBrowsingUsage', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusBrowsingUsage', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  async getBrowsingDuration({ commit, dispatch }, [key, type, record_size, from_date, end_date]) {

    commit('setLoadDataStatusBrowsing', {cancel:null, status:'loading', code:null});
    commit('setLoadDataStatusBrowsingDuration', 'loading');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/overall/browsing-duration', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {

      let data = resp.data;

      commit('setBrowsingDuration', data);

      if (data.chart_duration_app_cat.categories === undefined) {
        commit('setLoadDataStatusBrowsingDuration', 'empty');
      } else {
        commit('setLoadDataStatusBrowsingDuration', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusBrowsingDuration', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  async getBrowsingAccessDomain({ commit, dispatch }, [key, type, record_size, from_date, end_date]) {

    commit('setLoadDataStatusBrowsing', {cancel:null, status:'loading', code:null});
    commit('setLoadDataStatusBrowsingAccessDomain', 'loading');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/overall/browsing-access-domain', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {

      let data = resp.data;

      commit('setBrowsingAccessDomain', data);

      if (data.chart_access_app_cat.categories === undefined) {
        commit('setLoadDataStatusBrowsingAccessDomain', 'empty');
      } else {
        commit('setLoadDataStatusBrowsingAccessDomain', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusBrowsingAccessDomain', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  // ==============================================

  // api source (https://oilmine.xyz/)
  // getDeviceHistory({ getters,commit }, [imsi, record_size, from_date, end_date]) {
  async getDeviceHistory({ getters, commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {
    // console.log('================================= in getDeviceHistory()')
    // console.log(moment(from_date).format());
    // console.log(moment(end_date).format('YYYY-MM-DDT23:59:59Z'));

    // commit('setLoadDataStatusDeviceHistory',{cancel:null, status:'loading', code:null});
    if (state.load_data_status_device_history.cancel !== null && state.load_data_status_device_history.status === 'loading')
      await state.load_data_status_device_history.cancel('Operation canceled by the user.');

    // const prefixOperator = getters.getPrefixOperator;

    // var mnc = imsi.substring(0,5);

    // let params = {
    //   paging_direction: 'past',
    //   data_deduplication: 'true',
    //   source: 'sw2',
    //   // limit: 100,
    //   // from_datetime: '2020-01-01T00:00:00+07:00',
    //   // to_datetime: '2020-04-30T15:07:38+07:00',
    //   // user: '510016535481436',
    //   limit: record_size,
    //   from_datetime: moment(from_date).format(),
    //   to_datetime: moment(end_date).format('YYYY-MM-DDT23:59:59Z'),
    //   user: imsi,
    // };

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);

    // axios.get(source_api_url + prefixOperator[mnc] + '/v0/nstore_db/subintel.imei_change', {
    await axios.post(bff_master_api_url + 'api/v1/service/overall/device-history', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelDeviceHistory = c;
        commit('setLoadDataStatusDeviceHistory', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log('--------- in api getDeviceHistory()')
      // console.log(resp.data)
      let data = resp.data;
      // let code = (resp.response && resp.response.status ? resp.response.status : null)
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setDeviceHistory', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusDeviceHistory',{cancel:null, status:'empty', code:code});
        result.status = 'empty';
      }

      commit('setLoadDataStatusDeviceHistory', result);

    })
    .catch((resp) => {
      // console.log(resp)
      // let code = (resp.response && resp.response.status ? resp.response.status : null)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelDeviceHistory;
      }

      commit('setLoadDataStatusDeviceHistory', result);
      dispatch('handleErrors', result.code);
    });
  },

  // tethered device
  // getTetheredDevice({ getters, commit }, [imsi, from_datetime, to_datetime]) {
  async getTetheredDevice({ getters, commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {
    // console.log('================================= in getTetheredDevice()')
    // console.log(from_date)
    // console.log(end_date)
    // commit('setLoadDataStatusTetheredDevice', {cancel:null, status:'loading', code:null});
    if (state.load_data_status_tethered_device.cancel !== null && state.load_data_status_tethered_device.status === 'loading')
      await state.load_data_status_tethered_device.cancel('Operation canceled by the user.');

    // const prefixOperator = getters.getPrefixOperator;

    // var mnc       = imsi.substring(0,5);
    // var startDate = new Date(from_datetime).getTime() //1584316801 
    // var endDate   = new Date(to_datetime).getTime() //1586908799
    
    // let params = {
    //       paging_direction: 'past',
    //       // data_deduplication: 'true',
    //       source: 'sw2',
    //       // limit: 100,
    //       from_datetime: startDate,
    //       to_datetime: endDate,
    //       user: imsi,
    //     };

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    // params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);
    // var data = [
    //   {
    //     "tethered_device_vendor": "Apple",
    //     "tethered_device_tags": [
    //         "Device",
    //         "Mobile",
    //         "Smartphone",
    //         "2G",
    //         "3G",
    //           "LTE_FDD_BAND_25",
    //           "LTE_FDD_BAND_3",
    //           "LTE_FDD_BAND_4",
    //           "LTE_FDD_BAND_5",
    //           "LTE_FDD_BAND_7",
    //           "LTE_FDD_BAND_8",
    //           "Bluetooth",
    //           "WLAN",
    //           "LTE_TDD_BAND_40",
    //           "LTE_TDD_BAND_41",
    //           "LTE_FDD_BAND_28",
    //           "LTE_FDD_BAND_29",
    //           "LTE_FDD_BAND_26",
    //           "LTE_FDD_BAND_27",
    //           "LTE_TDD_BAND_34",
    //           "LTE_TDD_BAND_39",
    //           "LTE_TDD_BAND_38",
    //           "LTE_FDD_BAND_12",
    //           "VoLTE"
    //       ],
    //       "periods": [
    //           {
    //               "start": {
    //                   "timestamp": 1584415708.666,
    //                   "datetime": "2020-03-17 10:28:28"
    //               },
    //               "end": {
    //                   "timestamp": 1584423760.837,
    //                   "datetime": "2020-03-17 12:42:40"
    //               }
    //           },
    //           {
    //               "start": {
    //                   "timestamp": 1584599783.426,
    //                   "datetime": "2020-03-19 13:36:23"
    //               },
    //               "end": {
    //                   "timestamp": 1584603383.426,
    //                   "datetime": "2020-03-19 14:36:23"
    //               }
    //           },
    //           {
    //             "start": {
    //                 "timestamp": 1584599783.426,
    //                 "datetime": "2020-03-19 13:36:23"
    //             },
    //             "end": {
    //                 "timestamp": 1584603383.426,
    //                 "datetime": "2020-03-19 14:36:23"
    //             }
    //           }
    //       ],
    //       "tethered_device_name": "iPhone 6s Plus",
    //       "tethered_device": 13434
    //   },{
    //     "tethered_device_vendor": "Apple",
    //     "tethered_device_tags": [
    //         "Device",
    //         "Mobile",
    //         "Smartphone",
    //         "2G",
    //         "3G",
    //           "LTE_FDD_BAND_25",
    //           "LTE_FDD_BAND_3",
    //           "LTE_FDD_BAND_4",
    //           "VoLTE"
    //       ],
    //       "periods": [
    //           {
    //               "start": {
    //                   "timestamp": 1584415708.666,
    //                   "datetime": "2020-03-17 10:28:28"
    //               },
    //               "end": {
    //                   "timestamp": 1584423760.837,
    //                   "datetime": "2020-03-17 12:42:40"
    //               }
    //           },
    //       ],
    //       "tethered_device_name": "iPhone 6s Plus",
    //       "tethered_device": 13434
    //   },
    // ]    
    // commit('setTetheredDevice', data);
    // commit('setLoadDataStatusTetheredDevice', {cancel:null, status:true, code:code});
    // axios.get(source_api_url + prefixOperator[mnc]  +'/v0/nstore_db/subintel_imsi_tethered_device', {
    await axios.post(bff_master_api_url + 'api/v1/service/overall/tethered-device', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelTetheredDevice = c;
        commit('setLoadDataStatusTetheredDevice', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setTetheredDevice', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusTetheredDevice', {cancel:null, status:'empty', code:code});
        result.status = 'empty';
      }

      commit('setLoadDataStatusTetheredDevice', result);
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelTetheredDevice;
      }

      commit('setLoadDataStatusTetheredDevice', result);
      dispatch('handleErrors', result.code);
    });
  },

  // possible location
  async getPossibleLocation({ getters, commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {
    
    // commit('setLoadDataStatusPossibleLocation', {cancel:null, status:'loading', code:null});
    if (state.load_data_status_possible_location.cancel !== null && state.load_data_status_possible_location.status === 'loading')
      await state.load_data_status_possible_location.cancel('Operation canceled by the user.');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);
  
    // axios.get(source_api_url + prefixOperator[mnc]  +'/v0/nstore_db/subintel_imsi_tethered_device', {
    await axios.post(bff_master_api_url + 'api/v1/service/overall/possible-location', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelPossibleLocation = c;
        commit('setLoadDataStatusPossibleLocation', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log('=====getPossibleLocation:resp')
      // console.log(resp.data)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setPossibleLocation', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusPossibleLocation', {cancel:null, status:'empty', code:code});
        result.status = 'empty';

      } else {
        if (Object.keys(data.possible_home).length===0 && Object.keys(data.possible_office).length===0 && Object.keys(data.possible_top).length===0) {
          // commit('setLoadDataStatusPossibleLocation', {cancel:null, status:'empty', code:code});
          result.status = 'empty';

        } else if (Object.keys(data.possible_home).length===0 || Object.keys(data.possible_office).length===0 || Object.keys(data.possible_top).length===0) {
          // commit('setLoadDataStatusPossibleLocation', {cancel:null, status:'partially-empty', code:code});
          result.status = 'partially-empty';
        }

        commit('setLoadDataStatusPossibleLocation', result);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelPossibleLocation;
      }

      commit('setLoadDataStatusPossibleLocation', result);
      dispatch('handleErrors', result.code);
    });
  },

  // aerial log
  async getAerialLog({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {
    
    // commit('setLoadDataStatusAerialLog', {cancel:null,status:'loading', code:null});
    if (state.load_data_status_aerial_log.cancel !== null && state.load_data_status_aerial_log.status === 'loading')
      await state.load_data_status_aerial_log.cancel('Operation canceled by the user.');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);
  
    await axios.post(bff_master_api_url + 'api/v1/service/overall/aerial', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelAerialLog = c;
        commit('setLoadDataStatusAerialLog', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setAerialLog', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusAerialLog', {cancel:null,status:'empty', code:code});
        result.status = 'empty';

      } else {

        if (
          data.heatmap.length == 0 &&
          Object.keys(data.top_location.top_city).length == 0 &&
          Object.keys(data.top_location.top_province).length == 0 &&
          Object.keys(data.top_location.top_region).length == 0 &&
          Object.keys(data.top_location.top_village).length == 0
        ) {
          // commit('setLoadDataStatusAerialLog', {cancel:null,status:'empty', code:code});
          result.status = 'empty';

        } else if (
          data.heatmap.length == 0 ||
          Object.keys(data.top_location.top_city).length == 0 ||
          Object.keys(data.top_location.top_province).length == 0 ||
          Object.keys(data.top_location.top_region).length == 0 ||
          Object.keys(data.top_location.top_village).length == 0
        ) {
          // commit('setLoadDataStatusAerialLog', {cancel:null,status:'partially-empty', code:code});
          result.status = 'partially-empty';
        }

        commit('setLoadDataStatusAerialLog', result);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelAerialLog;
      }

      commit('setLoadDataStatusAerialLog', result);
      dispatch('handleErrors', result.code);
    });
  },

  // signal status
  async getSignalStatus({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {
    
    // commit('setLoadDataStatusSignalStatus', {cancel:null, status:'loading', code:null});
    if (state.load_data_status_signal_status.cancel !== null && state.load_data_status_signal_status.status === 'loading')
      await state.load_data_status_signal_status.cancel('Operation canceled by the user.');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type);
  
    await axios.post(bff_master_api_url + 'api/v1/service/overall/signal-status', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelSignalStatus = c;
        commit('setLoadDataStatusSignalStatus', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setSignalStatus', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusSignalStatus', {cancel:null, status:'empty', code:code});
        result.status = 'empty';

      } else {
        if (
          (typeof data.signal_status.categories == "undefined" || data.signal_status.categories.length == 0) &&
          data.signal_status.series.length == 0 &&
          data.summary['4G'] == 0 && data.summary['3G'] == 0 && data.summary['2G'] == 0
        ) {
          // commit('setLoadDataStatusSignalStatus', {cancel:null, status:'empty', code:code});
          result.status = 'empty';

        } else if (
          typeof data.signal_status.categories == "undefined" ||
          data.signal_status.categories.length == 0 ||
          data.signal_status.series.length == 0 ||
          data.summary['4G'] == 0 || data.summary['3G'] == 0 || data.summary['2G'] == 0
        ) {
          // commit('setLoadDataStatusSignalStatus', {cancel:null, status:'partially-empty', code:code});
          result.status = 'partially-empty';

        }
        
        commit('setLoadDataStatusSignalStatus', result);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelSignalStatus;
      }

      commit('setLoadDataStatusSignalStatus', result);
      dispatch('handleErrors', result.code);
    });
  },
    
  // ==============================================

  // travel history
  async getTravelHistory({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {
    
    // commit('setLoadDataStatusTravelHistory', {cancel:null, status:'loading', code:null});
    if (state.load_data_status_travel_history.cancel !== null && state.load_data_status_travel_history.status === 'loading')
      await state.load_data_status_travel_history.cancel('Operation canceled by the user.');

    let params = new FormData();

    // params.append('size', record_size);
    // params.append('from_date', from_date);
    // params.append('to_date', end_date);
    if (type === 'msisdn') {
      params.append('msisdn', key);
    } else {
      params.append('nik', key);
    }
    // params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/ehac/ehac-discover', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelTravelHistory = c;
        commit('setLoadDataStatusTravelHistory', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setTravelHistory', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusTravelHistory', {cancel:null, status:'empty', code:code});
        result.status = 'empty';
      }

      commit('setLoadDataStatusTravelHistory', result);
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelTravelHistory;
      }

      commit('setLoadDataStatusTravelHistory', result);
      dispatch('handleErrors', result.code);
    });
  },

  // ==============================================
  // travel pl
  async getTravelPl({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {
    
    // commit('setLoadDataStatusTravelHistory', {cancel:null, status:'loading', code:null});
    if (state.load_data_status_travel.cancel !== null && state.load_data_status_travel.status === 'loading')
      await state.load_data_status_travel.cancel('Operation canceled by the user.');

    let params = new FormData();

    // params.append('size', record_size);
    // params.append('from_date', from_date);
    // params.append('to_date', end_date);
    if (type === 'msisdn') {
      params.append('type', type);
      params.append('key', key);
    } else {
      params.append('type', type);
      params.append('key', key);
    }
    // params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/pl/travel', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelTravelHistory = c;
        commit('setLoadDataStatusTravel', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };
      try {
        if(Array.isArray(data.respond.content)) {
          commit('setTravel', data.respond.content);
        } else {
          commit('setTravel', []);
        }
      } catch (error) {        
        commit('setTravel', []);
      }

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusTravel', {cancel:null, status:'empty', code:code});
        result.status = 'empty';
      }

      commit('setLoadDataStatusTravel', result);
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelTravel;
      }

      commit('setLoadDataStatusTravel', result);
      dispatch('handleErrors', result.code);
    });
  },
  // ==============================================

  // Tokped
  async getTokped({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {
    
    // commit('setLoadDataStatusTokped',{cancel:null, status:'loading', code:null});
    if (state.load_data_status_tokped.cancel !== null && state.load_data_status_tokped.status === 'loading')
      await state.load_data_status_tokped.cancel('Operation canceled by the user.');

    let params = new FormData();

    if (type === 'msisdn') {
      params.append('msisdn', key);
    } else {
      params.append('email', key);
    }
    // params.append('size', record_size);
    // params.append('from_date', from_date);
    // params.append('to_date', end_date);
    params.append('msisdn', key);
    params.append('type', type);

    await axios.post(bff_master_api_url + 'api/v1/service/tokped/tokped-discover', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelTokped = c;
        commit('setLoadDataStatusTokped', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setTokped', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusTokped',{cancel:null, status:'empty', code:code});
        result.status = 'empty';
      }

      commit('setLoadDataStatusTokped', result);
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelTokped;
      }

      commit('setLoadDataStatusTokped', result);
      dispatch('handleErrors', result.code);
    });
  },

  // ==============================================

  // bank account
  async getBankAccount({ commit, dispatch, state }, [key, type]) {

    // commit('setLoadDataStatusBankAccount', {cancel:null, status:'loading', code:null});
    if (state.load_data_status_bank_account.cancel !== null && state.load_data_status_bank_account.status === 'loading')
      await state.load_data_status_bank_account.cancel('Operation canceled by the user.');

    let params = new FormData();
    if (type == 'msisdn') {
      params.append('key', key);
      params.append('msisdn', key);
    } else {
      key = state.profile_subheader?state.profile_subheader.msisdn:null
      params.append('key', key);
      params.append('msisdn', key);
    }

    // await axios.post(bff_master_api_url + 'api/v1/service/cc/list-cc', params, {
    await axios.post(bff_master_api_url + 'api/v1/service/cc/info-rek', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelBankAccount = c;
        commit('setLoadDataStatusBankAccount', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setBankAccount', data);

      // if (Object.keys(data).length===0) {
      if (data && data.data && data.data.length===0) {
        // commit('setLoadDataStatusBankAccount', {cancel:null, status:'empty', code:code});
        result.status = 'empty';
      }

      commit('setLoadDataStatusBankAccount', result);

    })
    .catch((resp) => {
      // console.log(resp.response.status)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelBankAccount;
      }

      commit('setLoadDataStatusBankAccount', result);
      dispatch('handleErrors', result.code);
    });
  },
  // ==============================================

  // personal identity
  async getPersonalIdentity({ commit, dispatch, state }, [key, type]) {

    // commit('setLoadDataStatusPersonalIdentity', {cancel:null, status:'loading', code:null});
    if (state.load_data_status_personal_identity.cancel !== null && state.load_data_status_personal_identity.status === 'loading')
      await state.load_data_status_personal_identity.cancel('Operation canceled by the user.');

    let params = new FormData();

    switch(type) {
      case 'msisdn':
        params.append('msisdn', key);
        break;

      case 'email':
        params.append('email', key);
        break;

      default:
        // 
    }

    await axios.post(bff_master_api_url + 'api/v1/service/personal_indentity/personal-data', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelPersonalIdentity = c;
        commit('setLoadDataStatusPersonalIdentity', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setPersonalIdentity', data);

      // if (Object.keys(data).length===0) {
      if (Object.keys(data).length === 0 || (typeof data['@persons_count'] !== "undefined" && data['@persons_count'] === 0)) {
        // commit('setLoadDataStatusPersonalIdentity', {cancel:null, status:'empty', code:code});
        result.status = 'empty';
      }
      
      commit('setLoadDataStatusPersonalIdentity', result);

    })
    .catch((resp) => {
      // console.log(resp.response.status)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelPersonalIdentity;
      }

      commit('setLoadDataStatusPersonalIdentity', result);
      dispatch('handleErrors', result.code);
    });
  },
  // ==============================================

  // vehicles / jasaraharja -> change to bff master vehicle -> old
  async getVehicles({ commit, dispatch, state }, [key, type, record_size, from_date, end_date]) {
    // console.log('================================= in getVehicles()')
    
    // commit('setLoadDataStatusVehicles',{cancel:null, status:'loading', code:null});
    commit('setVehiclesStatus', 'old');
    if (stateCancelVehicles !== null && state.load_data_status_vehicles.status === 'loading')
      await stateCancelVehicles('Operation canceled by the user.');

    let params = new FormData();

    params.append('size', record_size);
    params.append('from_date', from_date);
    params.append('to_date', end_date);
    params.append('key', key);
    params.append('type', type); // temporary? type = nopol

    // axios.post(jasaraharja_api_url + 'api/nopol', params, {
    // await axios.post(bff_master_api_url + 'api/v1/service/vehicle/nopol', params, {
    // await axios.post(bff_master_api_url + 'api/v1/service/vehicledata/nopol', params, {
      await axios.post(bff_master_api_url + 'api/v1/service/vehicleservice/vehicle', params, {

      // headers: defaultHeaders,
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelVehicles = c;
        commit('setLoadDataStatusVehicles', {cancel:null, status:'loading', code:null});
        stateCancelVehicles = c;
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let code = (resp.response && resp.response.status ? resp.response.status : null)
      // console.log('--------------- in vehicles api')
      // console.log(data)

      commit('setVehicles', data);
      stateCancelVehicles = null;

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusVehicles',{cancel:null, status:'empty', code:code});
        dispatch('getVehiclesData', key);

      } else {
        commit('setLoadDataStatusVehicles',{cancel:null, status:true, code:code});
      }
    })
    .catch((resp) => {
      // console.log(resp)
      // let code = (resp.response && resp.response.status ? resp.response.status : null)
      // commit('setLoadDataStatusVehicles',{cancel:null, status:'failed', code:code});
      // dispatch('handleErrors', code);


      // let status = 'failed';
      if (axios.isCancel(resp)) {
        // status = 'loading';
        stateCancelVehicles = cancelVehicles;

        // let result = {
        //   status: 'failed',
        //   cancel: null,
        //   code: resp.response && resp.response.status ? resp.response.status : null,
        // };

        // commit('setLoadDataStatusVehicles', result);
        // dispatch('handleErrors', result.code);

      } else {
        dispatch('getVehiclesData', key);
      }
    });
  },

  // vehicle data -> new
  async getVehiclesData({ commit, dispatch, state }, key) {

    // commit('setLoadDataStatusVehicles',{cancel:null, status:'loading', code:null});
    commit('setVehiclesStatus', 'new');
    if (stateCancelVehiclesData !== null && state.load_data_status_vehicles.status === 'loading')
      await stateCancelVehiclesData('Operation canceled by the user.');

    let params = new FormData();
    params.append('key', key);

    // await axios.post(bff_master_api_url + 'api/v1/service/vehicledata/nopol', params, {
      await axios.post(bff_master_api_url + 'api/v1/service/vehicleservice/vehicle', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelVehiclesData = c;
        commit('setLoadDataStatusVehiclesData', {cancel:null, status:'loading', code:null});
        stateCancelVehiclesData = c;
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let code = (resp.response && resp.response.status ? resp.response.status : null)

      commit('setVehicles', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusVehicles',{cancel:null, status:'empty', code:code});
      } else {
        commit('setLoadDataStatusVehicles',{cancel:null, status:true, code:code});
      }

      stateCancelVehiclesData = null;

    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      if (axios.isCancel(resp)) {
        result.status = 'loading';
        stateCancelVehiclesData = cancelVehiclesData;
      }

      commit('setLoadDataStatusVehicles', result);
      dispatch('handleErrors', result.code);
    });
  },

  // ==============================================
  
  // etilang / etle
  async getEtle({ commit, dispatch, state }, [key]) {
    
    // commit('setLoadDataStatusEtle',{cancel:null, status:'loading', code:null});
    if (state.load_data_status_etle.cancel !== null && state.load_data_status_etle.status === 'loading')
      await state.load_data_status_etle.cancel('Operation canceled by the user.');

    let params = new FormData();
    params.append('key', key);

    await axios.post(bff_master_api_url + 'api/v1/service/etle/nopol', params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelEtle = c;
        commit('setLoadDataStatusEtle', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      let data = resp.data;
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setEtle', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusEtle',{cancel:null, status:'empty', code:code});
        result.status = 'empty';
      }

      commit('setLoadDataStatusEtle', result);
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelEtle;
      }

      commit('setLoadDataStatusEtle', result);
      dispatch('handleErrors', result.code);
    });
  },
  
  // ==============================================

  // face recognition
  async getFaceRecognition({ state, commit, dispatch }, [isNew=true, image, limit='', gender='']) {
    // console.log('================================= in getFaceRecognition()')
    
    // commit('setLoadDataStatusFaceRecognition', 'loading');
    if (state.load_data_status_face_recognition.cancel !== null && state.load_data_status_face_recognition.status === 'loading')
      await state.load_data_status_face_recognition.cancel('Operation canceled by the user.');

    // let headers = defaultAuthHeaders;
    // headers['Content-Type'] = 'multipart/form-data; application/x-www-form-urlencoded';

    let url = '';
    let params = new FormData();

    if (isNew) {
      url = 'api/v1/service/face-reidentification/search';

      params.append('upload', image);

    } else {
      url = 'api/v1/service/mendagri/face-recognition-mendagri';

      // send as file, temporary?
      params.append('file', image);
      params.append('limit', limit);
      params.append('gender', gender);
    }

    // await axios.post(bff_master_api_url + 'api/v1/service/aiservice/face-recognition', params, {
    // await axios.post(bff_master_api_url + 'api/v1/service/mendagri/face-recognition-mendagri', params, {
    await axios.post(bff_master_api_url + url, params, {
      headers: defaultAuthHeaders,
      cancelToken: new CancelToken(function executor(c) {
        cancelFaceRecognition = c;
        commit('setLoadDataStatusFaceRecognition', {
          status: 'loading',
          cancel: c,
          code: null,
        });
      }),
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      // console.log(data)
      let result = {
        status: true,
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      commit('setFaceRecognition', data);

      if (Object.keys(data).length===0) {
        // commit('setLoadDataStatusFaceRecognition', 'empty');
        result = 'empty';
      }
      
      commit('setLoadDataStatusFaceRecognition', result);
    })
    .catch((resp) => {
      // console.log(resp)
      let result = {
        status: 'failed',
        cancel: null,
        code: resp.response && resp.response.status ? resp.response.status : null,
      };

      // if (axiosOrigin.isCancel(resp)) {
      if (axios.isCancel(resp)) {
        result.status = 'loading';
        result.cancel = cancelFaceRecognition;
      }

      commit('setLoadDataStatusFaceRecognition', result);
      dispatch('handleErrors', result.code);
    });
  },

  // unused
  // // async getProfileIdentity({ commit, dispatch }, [key, type]) {
  // async getPhotoKtpFaceRecognition({ dispatch }, nik) {

  //   let params = new FormData();

  //   params.append('key', nik);
  //   params.append('type', 'nik');

  //   return await new Promise((resolve, reject) => {
  //     axios.post(bff_master_api_url + 'api/v1/service/rig/ktp', params, {
  //         headers: defaultAuthHeaders,
  //     })
  //     .then((resp) => {
  //       // console.log(resp)
  //       let data = resp.data;

  //       if (Object.keys(data).length > 0) {
  //         resolve({result: 'success', data: data});
  //       } else {
  //         resolve({result: 'failed', data: data});
  //       }
  //     })
  //     .catch((resp) => {
  //       // console.log(resp.response)
  //       resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});

  //       dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
  //     });
  //   });
  // },

  // search by name
  async getSearchByName({ commit, dispatch }, [keyword, limit='10', page='1', gender='', province='', city='', district='', year_of_birth='', age_range='']) {
    // console.log('================================= in getSearchByName()')
    
    commit('setLoadDataStatusSearchByName', 'loading');

    let params = new FormData();

    params.append('keyword', keyword);
    // params.append('limit', limit);
    params.append('size', limit);
    params.append('page', page);
    params.append('is_new_system', 'yes');

    params.append('gender', gender);
    params.append('province', province);
    params.append('city', city);
    params.append('district', district);
    params.append('year_of_birth', year_of_birth);
    params.append('age_range', age_range);

    await axios.post(bff_master_api_url + 'api/v1/service/rig/search-ktp', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;

      commit('setSearchByName', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSearchByName', 'empty');
      } else {
        commit('setLoadDataStatusSearchByName', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusSearchByName', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },
  async getSearchByNameFilter({ commit, dispatch }, [type, id=null]) {
    
    // let type_title_case = type.charAt(0).toUpperCase() + type.slice(1);
    // console.log(type)
    commit('setLoadDataStatusSearchByNameFilter', [type, 'loading']);

    let params = new FormData();

    if (type === 'city') {
      params.append('province_id', id);
    } else if (type === 'district') {
      params.append('city_id', id);
    }
    // params.append('limit', 100);
    params.append('size', 100);

    await axios.post(bff_master_api_url + 'api/v1/service/rig/location-' + type, params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;

      commit('setSearchByNameFilter', [type, data]);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSearchByNameFilter', [type, 'empty']);
      } else {
        commit('setLoadDataStatusSearchByNameFilter', [type, true]);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusSearchByNameFilter', [type, 'failed']);
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

// search by name travel history
  async getSearchByNameTravelHistory({ commit, dispatch, getters }, [keyword, limit='10', page='1', gender='', age_min=0, age_max=200]) {
    console.log('================================= in getSearchByNameTravelHistory()')
    
    commit('setLoadDataStatusSearchByNameTravelHistory', 'loading');

    // const ageRange = getters.getDefaultAgeRange;
    // if (ageRange.set) {
    //   if (!age_min) {
    //     age_min=ageRange.min
    //   }
    //   if (!age_max) {
    //     age_max=ageRange.max
    //   }
    // }

    let params = new FormData();
    params.append('keyword', keyword);
    // params.append('name', keyword);
    // params.append('limit', limit);
    // params.append('page', page);

    // params.append('gender', gender);
    // params.append('minAge', age_min);
    // params.append('maxAge', age_max);

    // let url = bff_master_api_url + 'api/v1/service/ehac/ehac-search' //EHAC
    let url = bff_master_api_url + 'api/v1/service/travel/travel-history' //blackpi

    await axios.post(url, params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;

      commit('setSearchByNameTravelHistory', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSearchByNameTravelHistory', 'empty');
      } else {
        commit('setLoadDataStatusSearchByNameTravelHistory', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusSearchByNameTravelHistory', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

// search by name paspor
  async getSearchByNamePaspor({ commit, dispatch, getters }, [keyword, limit='10', page='1', gender='', age_min=0, age_max=200]) {
    console.log('================================= in getSearchByNamePaspor()')
    
    commit('setLoadDataStatusSearchByNamePaspor', 'loading');

    let checkKeyword = keyword.split(' ');

    let params = new FormData();
    
    if (checkKeyword.length >= 3) {
      let lastName = checkKeyword.pop(); 
      let firstName = checkKeyword.join(' '); 
      
      params.append('first_name', firstName);
      params.append('last_name', lastName);
    } else if (checkKeyword.length === 2) {
      params.append('first_name', checkKeyword[0]);
      params.append('last_name', checkKeyword[1]);
    } else if (checkKeyword.length === 1) {
      params.append('first_name', checkKeyword[0]);
    }
  
    // let params = new FormData();
    // params.append('keyword', keyword);

    // let url = bff_master_api_url + 'api/v1/service/travel/paspor' //blackpi
    let url = bff_master_api_url + 'api/v1/service/paspor/search-paspor'

    await axios.post(url, params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;

      commit('setSearchByNamePaspor', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSearchByNamePaspor', 'empty');
      } else {
        commit('setLoadDataStatusSearchByNamePaspor', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusSearchByNamePaspor', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  // search by name marketplace
  async getSearchByNameMarketplace({ commit, dispatch, getters }, [keyword, limit='10', page='1', gender='', year_of_birth='', age_min=0, age_max=200]) {
    // console.log('================================= in getSearchByNameMarketplace()')
    
    commit('setLoadDataStatusSearchByNameMarketplace', 'loading');

    const ageRange = getters.getDefaultAgeRange;
    if (ageRange.set) {
      if (!age_min) {
        age_min=ageRange.min
      }
      if (!age_max) {
        age_max=ageRange.max
      }
    }

    let params = new FormData();

    params.append('name', keyword);
    params.append('limit', limit);
    params.append('page', page);

    if (gender)
      params.append('gender', gender);
    
    if (year_of_birth)
      params.append('birthDate', year_of_birth);
    
    params.append('minAge', age_min);
    params.append('maxAge', age_max);

    await axios.post(bff_master_api_url + 'api/v1/service/tokped/tokped-search', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;

      commit('setSearchByNameMarketplace', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSearchByNameMarketplace', 'empty');
      } else {
        commit('setLoadDataStatusSearchByNameMarketplace', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusSearchByNameMarketplace', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  // search by name university
  async getSearchByNameUniversity({ commit, dispatch, getters }, [keyword]) {
    // console.log('================================= in getSearchByNameUniversity()')
    
    commit('setLoadDataStatusSearchByNameUniversity', 'loading');

    let params = new FormData();

    params.append('name', keyword);

    await axios.post(bff_master_api_url + 'api/v1/service/university/search-univ', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;

      commit('setSearchByNameUniversity', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSearchByNameUniversity', 'empty');
      } else {
        commit('setLoadDataStatusSearchByNameUniversity', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusSearchByNameUniversity', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  // search by name with name(last name & first name) or username
  async getSearchByNamePersonalIdentity({ commit, dispatch }, [keyword]) {
    // console.log('================================= in getSearchByNamePersonalIdentity()')
    
    commit('setLoadDataStatusSearchByNamePersonalIdentity', {cancel:null, status:'loading', code:null});

    let checkKeyword = keyword.split(' ');

    // console.log('checkKeyword')
    // console.log(checkKeyword)

    let params = new FormData();
    if (checkKeyword.length > 1) {
      params.append('first_name', checkKeyword[0]);

      checkKeyword.shift();
      
      if (checkKeyword.length > 1) {
        // checkKeyword = checkKeyword.join(' ');
        checkKeyword = checkKeyword[0];
      }

      params.append('last_name', checkKeyword);

    } else {
      params.append('username', keyword);
    }

    await axios.post(bff_master_api_url + 'api/v1/service/personal_indentity/personal-data', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp)
      let data = resp.data;
      let code = (resp.response && resp.response.status ? resp.response.status : null)

      commit('setSearchByNamePersonalIdentity', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSearchByNamePersonalIdentity', {cancel:null, status:'empty', code:code});
      } else {
        commit('setLoadDataStatusSearchByNamePersonalIdentity', {cancel:null, status:true, code:code});
      }
    })
    .catch((resp) => {
      // console.log(resp)
      let code = (resp.response && resp.response.status ? resp.response.status : null)

      commit('setLoadDataStatusSearchByNamePersonalIdentity', {cancel:null, status:'failed', code:code});
      dispatch('handleErrors', code);
    });
  },

   // ==============================================
  // pln
  async getSearchByNamePln({ commit, dispatch, state }, [keyword]) {    
    // console.log('================================= in getSearchByNamePln()')
    
    commit('setLoadDataStatusSearchByNamePln', 'loading');


    let params = new FormData();
    params.append('keyword', keyword);

    await axios.post(bff_master_api_url + 'api/v1/service/pln/blackpi-pln', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      console.log('resp pln', resp)
      let data = resp.data;
      console.log('data pln', data)

      try {
        if(Array.isArray(data.content)) {
          commit('setSearchByNamePln', data.content);
        } else {
          commit('setSearchByNamePln', []);
        }
      } catch (error) {        
        commit('setSearchByNamePln', []);
      }

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusSearchByNamePln', 'empty');
      } else {
        commit('setLoadDataStatusSearchByNamePln', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusSearchByNamePln', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  // notification
  fcmSubscribeToTopic({ state, commit }) {
    if (
      state.fcm_token !== null && 
      state.fcm_token !== '' && 
      process.env.VUE_APP_FCM_TOPIC !== null && 
      process.env.VUE_APP_FCM_TOPIC !== '' &&
      process.env.VUE_APP_FCM_SERVER_KEY !== null && 
      process.env.VUE_APP_FCM_SERVER_KEY !== ''
    ) {

      let params = new FormData();
      // params.append('size', 100);

      axios.post('https://iid.googleapis.com/iid/v1/'+ state.fcm_token +'/rel/topics/'+ process.env.VUE_APP_FCM_TOPIC, params, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'key='+ process.env.VUE_APP_FCM_SERVER_KEY
        },
      })
      // .then((resp) => {
      //   console.log(resp)
      // });

    } else {
      console.log('subscribe failed');

      if (state.fcm_token !== null || state.fcm_token !== '')
        console.log('fcm token is empty');

      if (process.env.VUE_APP_FCM_TOPIC !== null || process.env.VUE_APP_FCM_TOPIC !== '')
        console.log('fcm topic is empty');

      if (process.env.VUE_APP_FCM_SERVER_KEY !== null || process.env.VUE_APP_FCM_SERVER_KEY !== '')
        console.log('fcm serve key is empty');
    }
  },

  // getNotificationList({ commit, dispatch }, [limit=null, page=null, keyword=null, order_by=null, from_date=null, to_date=null]) {
  getNotificationList({ commit, dispatch }, [limit=null, page=null, type=null]) {
    // console.log('================================= in getNotificationList()')
    commit('setLoadDataStatusNotificationList', 'loading');

    let params = new FormData();

    params.append('limit', limit);
    params.append('page', page);
    params.append('type', type);
    // params.append('keyword', keyword);
    // params.append('order_by', order_by);
    // params.append('from_date', from_date);
    // params.append('to_date', to_date);
  
    axios.post(bff_master_api_url + 'api/v1/notification/list', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setNotificationList', data);

      if (Object.keys(data).length===0) {
        commit('setLoadDataStatusNotificationList', 'empty');
      } else {
        commit('setLoadDataStatusNotificationList', true);
      }
    })
    .catch((resp) => {
      // console.log(resp)
      commit('setLoadDataStatusNotificationList', 'failed');
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  getNotificationCount({ commit, dispatch }) {
    // console.log('================================= in getNotificationCount()')

    let params = new FormData();

    // params.append('limit', limit);
    // params.append('page', page);
    // params.append('keyword', keyword);
    // params.append('order_by', order_by);
    // params.append('from_date', from_date);
    // params.append('to_date', to_date);
  
    axios.post(bff_master_api_url + 'api/v1/notification/count', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
      let data = resp.data;
      commit('setNotificationCount', data);
    })
    .catch((resp) => {
      // console.log(resp)
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  // update notification as read
  async getUpdateNotification({ commit, dispatch }, id) {
    // console.log('================================= in getUpdateNotification()')

    let params = new FormData();
    
    params.append('id', id);
  
    await axios.post(bff_master_api_url + 'api/v1/notification/update', params, {
      headers: defaultAuthHeaders,
    })
    .then((resp) => {
      // console.log(resp.data)
    })
    .catch((resp) => {
      // console.log(resp)
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  async getUpdateAllNotification({ commit, dispatch }, type=null) {
    // console.log('================================= in getUpdateAllNotification()')

    let params = new FormData();
    
    params.append('type', type);
  
    await axios.post(bff_master_api_url + 'api/v1/notification/bulk-update', params, {
      headers: defaultAuthHeaders,
    })
    // .then((resp) => {
    //   console.log(resp.data)
    // })
    .catch((resp) => {
      // console.log(resp)
      dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
    });
  },

  // send target location
  getSendTargetLocation({ commit, dispatch }, [
    msisdn, 
    user_id, 
    fcm_device_id, 
    target_id, 
    target_name, 
    lat, 
    lng, 
    address='',
    bts='',
    imei='',
    imsi='',
    mcc='',
    lac='',
    ci='',
    ttype='',
    enb='',
    tac=''
  ]) {

    let params = new FormData();

    params.append('msisdn', msisdn);
    params.append('user_id', user_id);
    params.append('fcm_device_id', fcm_device_id);
    params.append('target_id', target_id);
    params.append('target_name', target_name);
    params.append('lat', lat);
    params.append('lng', lng);
    params.append('address', address);
    params.append('bts', bts);
    params.append('imei', imei);
    params.append('imsi', imsi);
    params.append('mcc', mcc);
    params.append('lac', lac);
    params.append('ci', ci);
    params.append('ttype', ttype);
    params.append('enb', enb);
    params.append('tac', tac);

    return new Promise((resolve, reject) => {

      axios.post(bff_master_api_url + 'api/v1/target-location/send', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
          console.log(resp)
          // commit('setProfileSubheader', resp.data);

          // if (resp.data && resp.data.token) {
          //   // localStorage.removeItem('auth_token');
          //   // localStorage.removeItem('auth_data');

          //   // localStorage.setItem('auth_token', resp.data.token);
          //   // localStorage.setItem('auth_data', JSON.stringify(resp.data.user));

          //   commit('setAuthToken', resp.data.token);
          //   commit('setAuthData', resp.data.user);

          //   authorization_token = 'Bearer ' + resp.data.token;
          //   defaultAuthHeaders['x-authorization'] = authorization_token;

          //   // resolve(resp);
          //   resolve({result: 'success', data: resp.data.user});
          // } else {
          //   resolve({result: 'failed', data: resp.data});
          // }
          resolve({result: 'success'});

      })
      .catch((resp) => {
        let code = (resp.response && resp.response.status ? resp.response.status : null)
        // console.log(resp)
        // resolve({result: 'failed', data: (resp.response && resp.response.data ? resp.response.data : null)});
        resolve({result: 'failed'});
        dispatch('handleErrors', code);
      });
    });
  },

  // map search place
  async getSearchMapPlaceList({ commit, dispatch }, keyword='') {
    // console.log('================================= in getSearchMapPlaceList()')

    let params = new FormData();
    
    params.append('query', keyword);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/retrieve-place/search', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        resolve({result: 'success', data: resp.data});
      })
      .catch((resp) => {
        resolve({result: 'failed', data: []});
        // console.log(resp)
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  async getSearchMapPlace({ commit, dispatch }, object_id) {
    // console.log('================================= in getSearchMapPlace()')

    let params = new FormData();
    
    params.append('object_id', object_id);
  
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/retrieve-place', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        resolve({result: 'success', data: resp.data});
      })
      .catch((resp) => {
        resolve({result: 'failed', data: {}});
        // console.log(resp)
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  // upload app
  async getDownloadApp({ commit, dispatch }) {
    // console.log('================================= in getDownloadApp()')

    return await new Promise((resolve, reject) => {
      axios.get(bff_master_api_url + 'api/v1/apk/download', {
        headers: defaultAuthHeaders,
        // params: params,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setDownloadApp', data);
        resolve({result: 'success', data: data});
      })
      .catch((resp) => {
        resolve({result: 'failed', data: {}});
        // console.log(resp)
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  async getUploadApp({ commit, dispatch }, [file_name, file]) {
    // console.log('================================= in getDownloadApp()')

    let params = new FormData();
    
    params.append('file_name', file_name);
    params.append('file', file);
  
    return await new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/apk/upload', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        resolve({result: 'success', data: resp.data});
      })
      .catch((resp) => {
        resolve({result: 'failed', data: {}});
        // console.log(resp)
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },

  // bot menu
  getBotMenuList({ commit, dispatch }, [user_id=null, client_id=null]) {
    // console.log('================================= in getRolesList()')
    commit('setLoadDataStatusBotMenuList', 'loading');
    
    let params = new FormData();
    params.append('user_id', user_id);

    if (client_id){
      params.append('client_id', client_id);
    }
    return new Promise((resolve, reject) => {
      axios.post(bff_master_api_url + 'api/v1/bot/menu', params, {
        headers: defaultAuthHeaders,
      })
      .then((resp) => {
        // console.log(resp.data)
        let data = resp.data;
        commit('setBotMenuList', data);


        if (Object.keys(data).length===0) {
          commit('setLoadDataStatusBotMenuList', 'empty');
        } else {
          commit('setLoadDataStatusBotMenuList', true);
        }

        resolve('success');
      })
      .catch((resp) => {
        // console.log(resp)
        commit('setLoadDataStatusBotMenuList', 'failed');
        resolve('failed');
        dispatch('handleErrors', (resp.response && resp.response.status ? resp.response.status : null));
      });
    });
  },
  setRecentLocation({ commit, state }, [resp=null, data=null]) {
    // console.log('resp.data aaaaaaaaa')
    // console.log(resp.data)
    // let code = (resp.response && resp.response.status ? resp.response.status : null)

    let result = {
      status: true,
      cancel: null,
      code: resp.response && resp.response.status ? resp.response.status : null,
    };
    data.recent_location = resp.data;
    commit('setOverallDataLocation', data);

    // console.log('state.overall_data_location')
    // console.log(state.overall_data_location)

    if (data.recent_location.features[0].geometry.coordinates && (data.recent_location.features[0].geometry.coordinates[0]==="" || data.recent_location.features[0].geometry.coordinates[1]==="")) {

      // commit('setLoadDataStatusOverallDataLocation','empty');
      result.status = 'empty';
      commit('setLoadDataStatusLocationRecent','empty');

    // } else if (data.recent_location.features[0].geometry.coordinates && (data.recent_location.features[0].geometry.coordinates[0]==="" || data.recent_location.features[0].geometry.coordinates[1]==="")) {

    //   commit('setLoadDataStatusOverallDataLocation',{cancel:null, status:false, code:code}'partially-empty');
    //   commit('setLoadDataStatusLocationRecent',{cancel:null, status:false, code:code}'partially-empty');
    } else {
      // commit('setLoadDataStatusOverallDataLocation',true);
      commit('setLoadDataStatusLocationRecent',true);
    }
    // console.log('setLoadDataStatusOverallDataLocation 5')
    // console.log(result)
    commit('setLoadDataStatusOverallDataLocation',result);
  },

  addApiResp({ commit }, dt=null) {
    var tmpApiResp;
    // var lsKey = key + '_' + service + '_' + module + '_' + record_size + '_' + from_date + '-' + to_date;
    if (!localStorage.getItem('listApiResp')) {
      tmpApiResp = [];
    } else {
      tmpApiResp = JSON.parse(localStorage.getItem('listApiResp'));
    }
    if (!(tmpApiResp instanceof Array)) {
      tmpApiResp = [];
    }
    tmpApiResp.push(dt.lsKey);
    // console.log('tmpApiResp')
    // console.log(tmpApiResp)
    localStorage.setItem('listApiResp', JSON.stringify(tmpApiResp));
    localStorage.setItem(dt.lsKey, JSON.stringify(dt.resp));
    // console.log("addApiResp localStorage.get('listApiResp')")
    // console.log(localStorage.get('listApiResp'))

  },

  async clearApiResp() {
    // console.log('masuk clear')
    // console.log(localStorage.get('listApiResp'))
    var tmpApiResp;
    if (!localStorage.getItem('listApiResp')) {
      tmpApiResp = [];
      // console.log('masuk clear []')
    } else {
      tmpApiResp = JSON.parse(localStorage.getItem('listApiResp'));
      // console.log('masuk clear ada')
      // console.log(tmpApiResp)
    }
    // console.log('masuk clear tmpApiResp')
    // console.log(tmpApiResp)
    if (!(tmpApiResp instanceof Array)) {
      tmpApiResp = [];
    }

    // console.log('masuk clear tmpApiResp')
    // console.log(tmpApiResp)
    try {
      tmpApiResp.forEach(k =>
        localStorage.removeItem(k)
      )
    } catch (error) {
      console.log('error remove')
      console.log(error)
    }

    localStorage.setItem('listApiResp', JSON.stringify([]));
  },
}
